/* Batterijenvoordeel offerte-calculator.
   Geldformules exact gelijk aan rekenmodel.ts. Wijzig nooit een van beide alleen.
   De zelfvoorzienendheid is een aparte benadering (seizoensmodel), zie uitleg op de site.
   v10 (3 okt 2026, besluit Luc): de rekenhulp kiest zelf het passende systeem, in drie lagen:
   1. uitsluiten wat niet kan (noodstroomwens, meesturen van andere apparaten),
   2. de maat als bandbreedte in plaats van een los getal (onderbouwing: KEUZELOGICA-CONFIGURATOR-24SEP.md),
   3. punten op wat de klant zelf belangrijk vindt; bij een gelijkspel wint de set met voorrang
      (veld vr: rangnummer uit de marges, bewust ZONDER bedragen in deze openbare code). */
(function () {
  'use strict';

  /* Constanten v3, geverifieerd 10 aug 2026. Zie REKENMODEL.md voor bronnen. */
  var C = {
    prijsInkoop: 0.26,
    prijsTerugleveringVast: 0.075,
    prijsTerugleveringDynamisch: 0.04,
    terugleverkostenVast: 0.115,
    terugleverkostenDynamisch: 0,
    rendement: 0.9,
    degradatiePerJaar: 0.02,
    cycliZon: 250,
    cycliHandel: 150,
    cycliHandelVerwacht: 280,
    prijsLaagLaden: 0.18,
    prijsHoogOntladen: 0.35,
    aandeelOverschot: 0.65,
    aandeelNachtverbruik: 0.6,
    /* v4: hoeveel van je nachtverbruik een batterij per nacht kan dekken hangt af van zijn grootte.
       Wat de batterij per nacht kan leveren = capaciteit x rendement; meer dan dat kan hij niet.
       Zonder deze grens leverde elke batterij bij een groot huis exact hetzelfde op (fout, gevonden 13 aug 2026). */
    dagenPerJaar: 365,
    /* 8 meter kabel zit in de prijs, daarboven 15 euro per meter (besluit Luc 10 sep 2026, taak 48) */
    kabelInbegrepen: 8,
    kabelPrijsPerMeter: 15,
    warmtefondsMax: 8500,
    warmtefondsLooptijdMaanden: 180,
    opwekPerPaneel: 400,
    /* Scenario zoals concurrenten rekenen; zie CALCULATORS-VAN-ANDEREN.md */
    prijsstijgingPerJaar: 0.03,
    netbalanceringPerKwh: 20,
    /* Zelfvoorzienendheid (v13, 5 okt 2026): uit de tabel van HTW Berlin, zie HTW_AUTARKIE hieronder.
       Die tabel rekent in kWp per 1.000 kWh verbruik; de rekenhulp kent de jaaropwek, en die is
       panelen x Wp x 0,9. Dus kWp = jaaropwek / 900. */
    opwekPerKwp: 900,
    /* v10: de maat-bandbreedte, in kWh per 1.000 kWh jaarverbruik.
       Ondergrens 1,0 = wat het huis 's avonds en 's nachts echt opneemt.
       Bovengrens vast contract 1,5 = de bovengrens van de HTW Berlin (meer levert vrijwel niets extra op),
       en nooit meer dan het dak op een zomerdag overhoudt.
       Bovengrens dynamisch contract 2,0 = handel vult de extra capaciteit wel.
       Onderbouwing: marktonderzoek/KEUZELOGICA-CONFIGURATOR-24SEP.md. */
    bandOnderPer1000: 1.0,
    bandBovenVastPer1000: 1.5,
    bandBovenDynPer1000: 2.0,
    /* v15 (12 okt 2026, taak 156): HTW Berlin (Orth, Weniger, Meissner 2022, nagelezen 8 okt 2026): een batterij
       die alleen met zonnestroom laadt, heeft hooguit 1,5 kWh bruikbare opslag per kWp zonnepanelen zin. Bij een
       vast contract laadt de batterij alleen van het dak, dus daar groeit het advies door grote verbruikers nooit
       verder mee dan deze grens. */
    htwMaxPerKwp: 1.5,
    /* 21 okt 2026 (taak 276, go Luc): de zelfvoorzienend-tabel van HTW Berlin rekent met 1.024 kWh opwek per kWp
       (solar.htw-berlin.de/faq-unabhaengigkeitsrechner, gelezen 21 okt 2026). Met onze 900 dacht de tabel dat elk
       dak 14% meer opwekte dan de klant invulde, tot boven wat het dak kan leveren. Alleen voor de tabel. */
    htwOpwekPerKwp: 1024
  };

  /* v15 (12 okt 2026, taak 156, opdracht Luc: "vult de klant x in, dan komt x eruit"; alles te herleiden):
     het extra stroomverbruik van grote verbruikers die er nog komen. Wat de klant al heeft, zit al in het
     jaarverbruik op zijn jaarafrekening en telt niet nog eens mee. Regel Luc (8 okt 2026): wat er nog komt,
     rekenen we ruim, met de bovenkant van de bron. Onderzoek: marktonderzoek/VERBRUIKERS-EN-CONTRACTEN-8OKT.md;
     de getallen hieronder zijn op 12 okt 2026 opnieuw bij de bron nagelezen, behalve waar "onderzoek 8 okt" staat. */
  var VERBRUIKERS = {
    warmtepomp: {
      /* Stroom per jaar = vermogen x vollasturen / rendement. id.nl (12 apr 2024): een ketel draait
         "gemiddeld 1.650 uren aan vollast"; dezelfde warmtevraag gaat naar de warmtepomp. Rendement 2,5:
         daarmee geeft 8 kW 5.280 kWh, gelijk aan de bovenkant van de tabel van Milieu Centraal (vrijstaand
         huis, 5.270 kWh), en 4 kW hybride 2.640 kWh, binnen de tabel voor hybride (tot 2.770 kWh). */
      vollasturen: 1650,
      rendement: 2.5,
      /* Vermogen onbekend: wat Milieu Centraal standaard noemt. Hybride 2 tot 6 kW, meestal 4 kW;
         volledig elektrisch 6 tot 12 kW, standaard 8 kW. Soort onbekend: volledig elektrisch, de ruimste. */
      standaardKw: { hybride: 4, volledig: 8 }
    },
    auto: {
      /* kWh per 100 km, bovenkant per klasse (EV Database, onderzoek 8 okt; ANWB: 15 tot 20 kWh per 100 km).
         Klasse onbekend: middenklasse. Kilometers onbekend: 18.100, het CBS-gemiddelde voor een elektrische auto (2024). */
      kwhPer100: { klein: 16.5, midden: 19, groot: 21 },
      standaardKm: 18100,
      /* Laadverlies thuis, ANWB met ADAC: laadpaal van 11 kW 6,3 tot 9,7 procent, gewoon stopcontact 12,7 tot
         24,2 procent; bovenkant. Laadwijze onbekend: laadpaal, de gewone manier bij een nieuwe auto. */
      verlies: { laadpaal: 0.097, stopcontact: 0.242 }
    },
    /* kWh per jaar per soort kookplaat (ANWB, Milieu Centraal). Soort onbekend: gietijzer, de hoogste. */
    kookplaat: { inductie: 175, keramisch: 225, gietijzer: 260 },
    airco: {
      /* Europees energielabel van de Daikin Perfera (datasheet en productblad, onderzoek 8 okt): per koelvermogen
         in kW het verbruik voor koelen en, als hij ook verwarmt, voor verwarmen, in kWh per jaar. Tussen twee maten
         rekenen we naar verhouding; boven 7,1 kW naar verhouding van 7,1 kW; onder 2 kW als 2 kW. */
      tabel: [[2.0, 74, 619], [2.5, 92, 647], [3.5, 132, 673], [4.2, 181, 1120], [5.0, 224, 1312], [6.0, 304, 1562], [7.1, 407, 2276]],
      /* 17 okt 2026, keuze Luc (A): het label is een laboratoriumsom (Daikin 3,5 kW: 2,5 kW x 1.400 uur / SCOP 5,1 = 686)
         en valt in de praktijk laag uit. Daarom nooit minder dan de praktijkwaarde, bovenkant van de bron:
         koelen 250 kWh (ANWB, vaste airco, gelezen 17 okt 2026); verwarmen 4.000 kWh warmte voor een woonkamer per
         stookseizoen / prestatiefactor 3 = 1.333 kWh (Selectra, bijgewerkt 8 sep 2026, gelezen 17 okt 2026).
         Ligt het label van een grotere airco hoger, dan telt het label.
         19 okt 2026, opdracht Luc: uitkomst 1.580 (3,5 kW) en 1.630 (leeg) houden, met de som zichtbaar voor de klant.
         Toets verwarmen, gelezen 19 okt 2026: Klima Comfort "voor een woonkamer doorgaans tussen de 800 en 1.800 kWh";
         Klimaatdienst (10 feb 2026) volledige verwarming 1,2 kWh x 8 uur x 4 maanden = 1.152 kWh. 1.333 ligt daarbinnen. */
      minimum: [250, 4000 / 3],
      warmte: 4000, prestatiefactor: 3,
      /* Vermogen onbekend: koelen als de veelgebruiker van Milieu Centraal (meer dan 30 dagen van ongeveer 10 uur, dus
         300 uur) met de mobiele airco, de onzuinigste soort (110 kWh in 110 uur, dus 1 kWh per uur): 300 kWh.
         Verwarmen als hierboven. */
      onbekendUren: 300,
      onbekend: [300, 4000 / 3]
    }
  };
  function nlGetal(n) { return Math.round(n).toLocaleString('nl-NL'); }
  function nlKomma(n) { return String(Math.round(n * 10) / 10).replace('.', ','); }
  function rond10(n) { return Math.round(n / 10) * 10; }
  /* Invoer per verbruiker: { stand: 'nee' | 'heb' | 'komt', ... }. Geeft het extra verbruik per jaar en per
     verbruiker één regel met de som erbij, zodat de klant en wij elk getal kunnen narekenen. */
  function extraVerbruik(a) {
    a = a || {};
    var V = VERBRUIKERS, regels = [], totaal = 0;
    /* aanname = de klant liet kilometers of vermogen leeg en we rekenen met de standaardwaarde (19 okt 2026, Gianni punt 7) */
    function regel(key, naam, stand, kwh, som, aanname) {
      regels.push({ key: key, naam: naam, stand: stand, kwh: kwh, som: som, aanname: !!aanname });
      if (stand === 'komt') totaal += kwh;
    }
    var w = a.warmtepomp;
    if (w && (w.stand === 'heb' || w.stand === 'komt')) {
      var soort = w.soort === 'hybride' ? 'hybride' : 'volledig';
      var kw = w.kw > 0 ? w.kw : V.warmtepomp.standaardKw[soort];
      var kwhW = rond10(kw * V.warmtepomp.vollasturen / V.warmtepomp.rendement);
      regel('warmtepomp', 'Warmtepomp, ' + (soort === 'hybride' ? 'hybride' : 'volledig elektrisch') + ', ' + nlKomma(kw) + ' kW', w.stand, kwhW,
        nlKomma(kw) + ' kW x ' + nlGetal(V.warmtepomp.vollasturen) + ' vollasturen / rendement ' + nlKomma(V.warmtepomp.rendement), !(w.kw > 0));
    }
    var e = a.auto;
    if (e && (e.stand === 'heb' || e.stand === 'komt')) {
      var klasse = V.auto.kwhPer100[e.klasse] ? e.klasse : 'midden';
      var km = e.km > 0 ? e.km : V.auto.standaardKm;
      var verlies = e.laden === 'stopcontact' ? V.auto.verlies.stopcontact : V.auto.verlies.laadpaal;
      var per100 = V.auto.kwhPer100[klasse];
      var kwhE = rond10(km / 100 * per100 * (1 + verlies));
      regel('auto', 'Elektrische auto, ' + nlGetal(km) + ' km per jaar', e.stand, kwhE,
        nlGetal(km) + ' km x ' + nlKomma(per100) + ' kWh per 100 km + ' + nlKomma(verlies * 100) + '% laadverlies', !(e.km > 0));
    }
    var k = a.kookplaat;
    if (k && (k.stand === 'heb' || k.stand === 'komt')) {
      var ks = V.kookplaat[k.soort] ? k.soort : 'gietijzer';
      regel('kookplaat', 'Elektrische kookplaat, ' + (ks === 'gietijzer' ? 'gietijzer' : ks), k.stand, V.kookplaat[ks], 'gemiddeld verbruik per jaar');
    }
    var c = a.airco;
    if (c && (c.stand === 'heb' || c.stand === 'komt')) {
      var koel, warm;
      if (c.kw > 0) {
        var T = V.airco.tabel, x = c.kw;
        if (x <= T[0][0]) { koel = T[0][1]; warm = T[0][2]; }
        else if (x >= T[T.length - 1][0]) { var t = T[T.length - 1]; koel = t[1] * x / t[0]; warm = t[2] * x / t[0]; }
        else {
          for (var i = 1; i < T.length; i++) if (x <= T[i][0]) {
            var f = (x - T[i - 1][0]) / (T[i][0] - T[i - 1][0]);
            koel = T[i - 1][1] + (T[i][1] - T[i - 1][1]) * f; warm = T[i - 1][2] + (T[i][2] - T[i - 1][2]) * f; break;
          }
        }
      } else { koel = V.airco.onbekend[0]; warm = V.airco.onbekend[1]; }
      var labelKoel = koel, labelWarm = warm;
      koel = Math.max(koel, V.airco.minimum[0]); warm = Math.max(warm, V.airco.minimum[1]);
      var kwhC = rond10(koel + (c.verwarmen === 'ja' ? warm : 0));
      /* De som zoals de klant hem kan narekenen, net als bij warmtepomp en auto */
      var somKoel = !(c.kw > 0) ? 'koelen ' + V.airco.onbekendUren + ' uur x 1 kWh'
        : koel > labelKoel ? 'koelen ' + nlGetal(koel) + ' kWh' : 'koelen ' + nlGetal(koel) + ' kWh volgens energielabel';
      var somWarm = warm > labelWarm || !(c.kw > 0) ? 'verwarmen ' + nlGetal(V.airco.warmte) + ' kWh warmte / rendement ' + V.airco.prestatiefactor
        : 'verwarmen ' + nlGetal(warm) + ' kWh volgens energielabel';
      regel('airco', 'Airco' + (c.kw > 0 ? ', ' + nlKomma(c.kw) + ' kW' : '') + (c.verwarmen === 'ja' ? ', koelen en verwarmen' : ', koelen'), c.stand, kwhC,
        somKoel + (c.verwarmen === 'ja' ? ' + ' + somWarm : ''), !(c.kw > 0));
    }
    return { totaal: totaal, regels: regels };
  }

  /* v9 (30 sep 2026, besluit Luc): elk merk een eigen prijslijst op 1 fase en op 3 fasen.
     Er bestaat geen meerprijs voor 3 fasen meer: elke set heeft zijn eigen omvormer en zijn eigen prijs.
     De regels tussen BATTERIJEN-BEGIN en BATTERIJEN-EIND worden geschreven door
     hulpscripts/prijzen-v9/site-data.js uit prijzen-en-offertes/prijslijst.json; niet met de hand wijzigen.
     Per fase: capaciteiten[i] = bruikbare kWh van maat i; prijzen[i] = prijs; varianten[i] = Shopify-variant-ID
     (voor de koopknop); samenstelling[i] = hoe die maat is opgebouwd, in gewone taal; vr[i] = voorrang bij een
     gelijkspel (1 = eerste keus; rangnummer, geen bedrag); routes = hoe de set op de zonnepanelen komt:
     'beide' = klant kiest bij de schouw, 'beide-meerprijs' = keuze, maar de hybride uitvoering kost extra
     (hybride = die meerprijs in euro's).
     De velden op merkniveau (capaciteiten, prijzen, varianten, samenstelling) zijn de 1-fase lijst, voor
     scripts die nog per merk rekenen (hulpscripts/cijfers.js). */
  var BATTERIJEN = [
    /* BATTERIJEN-BEGIN */
    { id: 'foxess-ep-serie', naam: 'FoxESS EP-serie', merk: 'FoxESS', klasse: 'De slimme keuze', capaciteit: 5.2, moduleKwh: 5.2, maxKwh: 41.5, capaciteiten: [5.2, 10.4, 15.6, 20.7, 31.1], samenstelling: ['1 kleine module', '1 grote module', '3 kleine modules', '2 grote modules', '3 grote modules'], prijzen: [4800, 5800, 7050, 8500, 11350], varianten: ['54690131116371', '54690131149139', '54690131181907', '54690131214675', '54690131247443'], garantie: '10 jaar op de batterij', positionering: 'De slimme keuze: alles van één merk, in zes maten', handle: 'foxess-ep-serie', routes: 'beide', fasen: { '1': { capaciteiten: [5.2, 10.4, 15.6, 20.7, 31.1], samenstelling: ['1 kleine module', '1 grote module', '3 kleine modules', '2 grote modules', '3 grote modules'], prijzen: [4800, 5800, 7050, 8500, 11350], varianten: ['54690131116371', '54690131149139', '54690131181907', '54690131214675', '54690131247443'], vr: [13, 14, 19, 9, 3], routes: 'beide' }, '3': { capaciteiten: [5.2, 10.4, 15.6, 20.7, 31.1, 41.5], samenstelling: ['1 kleine module', '1 grote module', '3 kleine modules', '2 grote modules', '3 grote modules', '4 grote modules'], prijzen: [5250, 6400, 7650, 8500, 10900, 14000], varianten: ['55116133564755', '55116133597523', '55116133630291', '55116133663059', '55116133695827', '55116133728595'], vr: [17, 18, 16, 20, 15, 4], routes: 'beide' } } },
    { id: 'sigenergy-sigenstor', naam: 'Sigenergy SigenStor', merk: 'Sigenergy', klasse: 'Het topsysteem', capaciteit: 8.8, moduleKwh: 8.76, maxKwh: 52.6, capaciteiten: [8.8, 17.5, 26.3], samenstelling: ['1 module', '2 modules', '3 modules'], prijzen: [7350, 10500, 13500], varianten: ['54542442791251', '54631298335059', '54631298367827'], garantie: '10 jaar', positionering: 'Het topsysteem: het slimste systeem, uit te breiden tot zes batterijen', handle: 'sigenergy-sigenstor', routes: 'beide', fasen: { '1': { capaciteiten: [8.8, 17.5, 26.3], samenstelling: ['1 module', '2 modules', '3 modules'], prijzen: [7350, 10500, 13500], varianten: ['54542442791251', '54631298335059', '54631298367827'], vr: [11, 8, 6], routes: 'beide' }, '3': { capaciteiten: [8.8, 17.5, 26.3, 35, 43.8, 52.6], samenstelling: ['1 module', '2 modules', '3 modules', '4 modules', '5 modules', '6 modules'], prijzen: [8050, 11400, 14800, 17800, 20800, 23800], varianten: ['55116133761363', '55116133794131', '55116133826899', '55116133859667', '55429791875411', '55388140077395'], vr: [12, 10, 7, 5, 2, 1], routes: 'beide' } } }
    /* BATTERIJEN-EIND */
  ];

  /* v10: vaste eigenschappen per systeem, voor de merkkeuze. Deze staan BUITEN het gegenereerde blok
     en veranderen alleen als een fabrikant of groothandel iets anders bevestigt.
     Bronnen: FoxESS H1-G2 en P3-SH datasheets (noodstroomuitgang in de omvormer, omschakeling onder
     20 ms; voor het hele huis is een aparte EPS-box nodig die niet in de set zit). Sigenergy: noodstroom alleen met de losse
     Sigen Gateway, die niet in de set zit (prijslijst.json, onze merkpagina en de configurator; de
     installatiegids van Sigenergy noemt het gateway-kastje verplicht voor noodstroom).
     CORRECTIE 4 okt 2026: op 3 okt stond hier bij Sigenergy "standaard". Dat was nooit bewezen en sprak
     onze eigen merkpagina tegen; zie luc-regressions.md.
     Eniris dekt Sigenergy, FoxESS niet (STURING PER SYSTEEM.md, 23 sep 2026).
     9 okt 2026 (taak 171, besluit Luc 8 okt): alleen nog FoxESS en Sigenergy. */
  var EIGEN = {
    'foxess-ep-serie': {
      key: 'foxess',
      eenMerk: true,
      eniris: false,
      noodstroom: { '1': 'ingebouwd', '3': 'ingebouwd' },
      groeiTot: { '1': 41.5, '3': 41.5 }
    },
    'sigenergy-sigenstor': {
      key: 'sigenergy',
      eenMerk: true,
      eniris: true,
      noodstroom: { '1': 'los', '3': 'los' },
      groeiTot: { '1': 52.6, '3': 52.6 }
    }
  };
  var NOODSTROOM_TEKST = {
    /* 12 okt 2026: gelijk aan de standaard van de configurator (taak 178): niet in de prijs, schouw, prijsopgave */
    ingebouwd: 'zit een noodstroomuitgang in de omvormer. Noodstroom zit niet standaard in de prijs; de installateur bekijkt het bij de schouw en wij maken een prijsopgave',
    los: 'kan noodstroom met de losse Sigen Gateway. Noodstroom zit niet standaard in de prijs; de installateur bekijkt het bij de schouw en wij maken een prijsopgave',
    geen: 'is er geen noodstroomaansluiting'
  };
  var VOORKEUR_TEKST = {
    rendement: 'snel terugverdienen',
    zelf: 'zo zelfvoorzienend mogelijk',
    noodstroom: 'doorwerken bij stroomuitval',
    eenmerk: 'alles van één merk',
    uitbreiden: 'later kunnen uitbreiden',
    meesturen: 'warmtepomp, laadpaal of airco meesturen'
  };

  /* Kies per merk de maat die de adviescapaciteit haalt, op de aansluiting van de klant ('1' of '3';
     onbekend rekent met 1 fase), en geef die terug als "batterij" */
  function configureer(bat, doelKwh, fase) {
    /* v7: kies de maat waarvan de capaciteit het dichtst bij het advies ligt (bij gelijke afstand de
       goedkoopste, want de lijst loopt op in prijs). Zo zetten we geen module van 11,5 kWh bij voor
       2,5 kWh tekort, en laten we een merk ook niet onnodig klein als een maat erbij veel beter past. */
    var f = fase === '3' ? '3' : '1';
    var lijst = (bat.fasen && bat.fasen[f]) || bat;
    var caps = lijst.capaciteiten;
    var modules = 0, beste = Math.abs(caps[0] - doelKwh);
    for (var n = 1; n < caps.length; n++) {
      var afstand = Math.abs(caps[n] - doelKwh);
      if (afstand < beste - 0.001) { beste = afstand; modules = n; }
    }
    return maat(bat, f, modules);
  }

  /* Eén maat van één merk als compleet "batterij"-object */
  function maat(bat, f, index) {
    var lijst = (bat.fasen && bat.fasen[f]) || bat;
    var kopie = {};
    for (var k in bat) kopie[k] = bat[k];
    kopie.fase = f;
    kopie.capaciteit = lijst.capaciteiten[index]; kopie.prijs = lijst.prijzen[index]; kopie.modules = index;
    kopie.basisCapaciteit = lijst.capaciteiten[0]; kopie.maatTekst = lijst.samenstelling[index];
    kopie.routes = lijst.routes || bat.routes;
    kopie.variant = lijst.varianten[index];
    kopie.vr = (lijst.vr && lijst.vr[index]) || 99;
    kopie.url = '/products/' + bat.handle + (kopie.variant ? '?variant=' + kopie.variant : '');
    return kopie;
  }

  function terugverdientijd(investering, opbrengst, prijsstijging) {
    if (opbrengst <= 0) return null;
    var groei = prijsstijging || 0;
    var cum = 0;
    for (var t = 1; t <= 30; t++) {
      cum += opbrengst * Math.pow(1 - C.degradatiePerJaar, t - 1) * Math.pow(1 + groei, t - 1);
      if (cum >= investering) return t;
    }
    return null;
  }

  /* v21 (23 okt 2026, taak 100, go Luc: "Dit wordt de nieuwe standaard, de oude regels gaan eruit"): de zonnestroom uit
     de batterij komt uit een natuurkundige jaarsimulatie, uur voor uur. Vervangen zijn de regels "hooguit 30% van de opwek
     extra", "hooguit 200 keer per jaar vol" en "per nacht hooguit 1,5 kWh per 1.000 kWh"; daardoor gaf elke maat batterij
     bij hetzelfde huis dezelfde opbrengst. Nu heeft elke maat een eigen uitkomst.
     1. Harde besparing: eigen zonnestroom die de batterij bewaart voor de avond en de nacht.
        - Zonnestroom uit de batterij: tabel SIM_BATTERIJ hieronder, gemaakt met hulpscripts/natuurkunde-23okt/maaktabel.py.
          8.760 uur zon (PVGIS 5.3 van het JRC, Echt, 2023, zuid 35 graden, 14% verlies) tegen verbruik (standaardprofiel
          E1A 2023 v1.02, energiedatawijzer.nl: slimme meters 2019-2021, zonder teruglevering). De batterij laadt met wat
          het dak overhoudt en levert terug bij tekort, 85% heen en terug, 5 kW (maakt per uur geen verschil, getest).
          Rijen SIM_Y: bruikbare opslag in kWh per 1.000 kWh jaarverbruik; kolommen SIM_X: opwek per kWh jaarverbruik;
          waarde: kWh uit de batterij per 1.000 kWh jaarverbruik, maal 10. Opgehaald en gemaakt op 23 okt 2026.
        - Geijkt op een meting (M.ijk): CE Delft voor VEH, jan 2026, p. 65, huishouden 4: 4.875 kWh verbruik, 4.001 kWh
          zon, 5 kWh batterij, gemeten 988 kWh uit de batterij; de simulatie geeft 1.078 kWh; 988 / 1.078 = 0,916.
        - Nooit meer uit de batterij dan wat er anders teruggaat naar het net, maal het rendement.
        - Verlies bij laden en ontladen 15% (CE Delft 2026: "zo'n 15%"; hun eigen meting gaf 19 en 24%).
        - Waarde per bewaarde kWh, vast: 0,31 euro (Keuze.nl, gemiddeld 1 jaar vast inclusief btw en energiebelasting,
          peiling 21 okt 2026) min 0,5 cent gemiste netto terugleververgoeding (Stroomwekker, 15 aug 2026: vergoeding min
          terugleverkosten 2027 bij zeven leveranciers 0,20 tot 1,57 cent). Zo telt de terugleverboete die de batterij
          wegneemt mee.
        - Waarde per bewaarde kWh, dynamisch: de avond- en nachtprijs tegen de middagprijs, gemeten op de echte uurprijzen
          van Nederland in 2025 (Energy-Charts, Bundesnetzagentur/SMARD, CC BY 4.0), met energiebelasting 2027 van 8,802
          cent zonder btw (Fiscale sleuteltabel 2027) en een inkoopvergoeding van 2 cent (AANNAME, geen bron). Avond
          17-23 uur all-in 0,2713; middag 10-16 uur april tot september kaal 0,0225. Berekend in
          hulpscripts/rekenmethode-20okt/maakdata.js.
     2. EPEX-handel, alleen dynamisch: 100 extra laadbeurten per jaar (Luc, 21 okt 2026). Per laadbeurt 0,109 euro per kWh
        opslag: Berenschot voor Zonneplan, 12 juni 2025, p. 22, handel op energiemarkten met de dubbele energiebelasting van
        2027: 370 euro winst bij 178 laadbeurten van 19 kWh (zelf gelezen 21 okt 2026).
     3. Veroudering 2,5% opslag per jaar (RWTH Aachen, Figgener e.a. 2024: 2 tot 3 procentpunt per jaar).
     De prijs komt van de aanroeper: bij dynamisch de prijs na btw-teruggave (zie metNaBtw), bij vast inclusief btw.
     jaar1 en tv zijn de harde besparing, jaar1Verwacht en tvVerwacht de harde besparing plus handel. */
  var M = { rendement: 0.85, handelBeurten: 100, ijk: 0.916,
    tariefVast: 0.31, terugVastNetto: 0.005, avondDyn: 0.2713, middagDyn: 0.0225,
    handelPerKwh: 0.109, veroudering: 0.025 };
  /* SIM-BEGIN (gemaakt door hulpscripts/natuurkunde-23okt/maaktabel.py, niet met de hand wijzigen) */
  var SIM_X = [0.0,0.125,0.25,0.375,0.5,0.625,0.75,0.875,1.0,1.125,1.25,1.375,1.5,1.625,1.75,1.875,2.0,2.125,2.25,2.375,2.5,2.625,2.75,2.875,3.0,3.125,3.25,3.375,3.5,3.625,3.75,3.875,4.0];
  var SIM_Y = [0.0,0.25,0.5,0.75,1.0,1.25,1.5,1.75,2.0,2.25,2.5,2.75,3.0,3.25,3.5,3.75,4.0,4.5,5,5.5,6,6.5,7,7.5,8,9,10,11,12,13,14,15,16,18,20,22,24,26,28,30];
  var SIM_BATTERIJ = [
    [0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0],
    [0,1,270,469,564,624,661,685,703,718,735,750,760,768,774,779,784,789,792,796,800,803,807,810,812,815,818,821,823,826,828,830,832],
    [0,1,335,753,976,1106,1194,1258,1305,1340,1370,1396,1419,1440,1459,1475,1488,1498,1506,1514,1522,1529,1536,1543,1550,1556,1562,1568,1575,1581,1587,1593,1598],
    [0,1,335,921,1293,1515,1662,1767,1850,1916,1971,2012,2047,2078,2107,2132,2155,2176,2194,2210,2223,2235,2246,2256,2267,2277,2286,2295,2304,2313,2321,2330,2338],
    [0,1,335,998,1522,1853,2073,2231,2347,2444,2523,2593,2647,2690,2726,2760,2791,2817,2839,2860,2879,2894,2909,2922,2934,2945,2955,2965,2975,2985,2994,3003,3011],
    [0,1,335,1008,1677,2109,2396,2595,2737,2840,2933,3007,3071,3123,3163,3196,3225,3254,3280,3302,3321,3340,3357,3372,3385,3399,3411,3423,3435,3446,3456,3466,3475],
    [0,1,335,1008,1731,2222,2560,2790,2948,3066,3156,3239,3305,3361,3409,3448,3486,3518,3547,3573,3598,3619,3638,3657,3675,3693,3709,3723,3737,3751,3764,3778,3791],
    [0,1,335,1008,1753,2277,2654,2910,3082,3205,3305,3385,3458,3519,3570,3618,3662,3701,3739,3768,3792,3818,3841,3864,3884,3902,3921,3940,3957,3973,3989,4005,4020],
    [0,1,335,1008,1766,2318,2707,2989,3169,3294,3394,3477,3549,3612,3673,3726,3776,3822,3859,3892,3920,3947,3972,3997,4019,4040,4061,4081,4101,4122,4140,4157,4174],
    [0,1,335,1008,1771,2345,2746,3050,3237,3358,3462,3548,3620,3688,3751,3811,3863,3912,3953,3986,4015,4044,4071,4096,4120,4143,4167,4189,4210,4230,4251,4271,4291],
    [0,1,335,1008,1775,2369,2779,3093,3283,3409,3506,3594,3673,3743,3808,3869,3925,3975,4016,4051,4083,4111,4137,4165,4191,4215,4239,4264,4286,4309,4331,4351,4371],
    [0,1,335,1008,1777,2390,2807,3124,3326,3447,3544,3630,3712,3788,3853,3915,3970,4020,4065,4102,4134,4165,4193,4221,4249,4276,4303,4328,4352,4375,4398,4420,4439],
    [0,1,335,1008,1780,2409,2832,3154,3362,3479,3573,3658,3742,3822,3893,3954,4008,4059,4105,4146,4181,4211,4243,4274,4303,4331,4360,4388,4412,4434,4456,4477,4496],
    [0,1,335,1008,1782,2424,2850,3181,3389,3503,3596,3684,3769,3851,3928,3989,4040,4092,4141,4184,4222,4256,4288,4320,4353,4381,4410,4438,4464,4486,4506,4526,4545],
    [0,1,335,1008,1784,2434,2869,3203,3404,3521,3617,3707,3792,3875,3952,4015,4070,4122,4174,4220,4259,4294,4329,4364,4395,4423,4453,4480,4507,4530,4551,4571,4588],
    [0,1,335,1008,1787,2443,2883,3224,3415,3538,3637,3727,3814,3895,3967,4037,4096,4150,4202,4252,4293,4329,4363,4397,4430,4458,4488,4518,4544,4569,4591,4611,4628],
    [0,1,335,1008,1789,2450,2897,3243,3424,3554,3656,3747,3835,3912,3981,4052,4120,4175,4228,4279,4321,4357,4390,4424,4460,4493,4522,4551,4577,4602,4625,4645,4663],
    [0,1,335,1008,1793,2459,2925,3264,3443,3583,3685,3782,3864,3937,4008,4078,4151,4222,4275,4327,4370,4408,4442,4478,4514,4547,4580,4606,4632,4658,4680,4703,4726],
    [0,1,335,1008,1798,2469,2950,3282,3457,3602,3712,3806,3889,3960,4031,4101,4175,4251,4316,4368,4413,4455,4493,4529,4562,4593,4626,4655,4682,4704,4726,4749,4773],
    [0,1,335,1008,1803,2473,2968,3295,3468,3616,3735,3829,3910,3982,4054,4124,4198,4274,4350,4409,4455,4496,4535,4574,4607,4638,4670,4699,4723,4746,4767,4789,4811],
    [0,1,335,1008,1807,2478,2985,3309,3477,3625,3757,3852,3929,4001,4077,4147,4221,4297,4373,4445,4495,4533,4572,4611,4647,4677,4708,4731,4755,4781,4804,4826,4848],
    [0,1,335,1008,1812,2482,2999,3314,3486,3634,3772,3875,3947,4019,4097,4170,4244,4320,4396,4470,4526,4567,4605,4643,4679,4713,4740,4763,4788,4813,4839,4863,4885],
    [0,1,335,1008,1816,2487,3013,3319,3495,3643,3782,3898,3966,4038,4115,4192,4267,4343,4419,4493,4549,4595,4637,4675,4711,4742,4771,4796,4820,4845,4870,4897,4919],
    [0,1,335,1008,1816,2492,3024,3324,3505,3652,3791,3914,3984,4056,4133,4211,4290,4366,4442,4516,4572,4618,4665,4707,4740,4767,4796,4824,4848,4872,4898,4924,4944],
    [0,1,335,1008,1816,2496,3033,3328,3514,3662,3800,3926,4002,4075,4152,4229,4309,4389,4464,4537,4592,4637,4684,4732,4763,4790,4818,4847,4873,4896,4919,4942,4963],
    [0,1,335,1008,1816,2505,3051,3338,3529,3680,3819,3944,4034,4105,4182,4258,4337,4420,4501,4574,4629,4674,4717,4759,4800,4825,4851,4878,4906,4928,4950,4972,4988],
    [0,1,335,1008,1816,2515,3066,3347,3538,3699,3837,3963,4057,4133,4209,4286,4365,4448,4529,4609,4665,4702,4740,4780,4820,4853,4878,4905,4933,4956,4978,4997,5006],
    [0,1,335,1008,1816,2524,3076,3356,3547,3717,3856,3981,4076,4160,4237,4313,4393,4475,4556,4629,4681,4721,4759,4799,4838,4875,4906,4933,4961,4984,5005,5016,5025],
    [0,1,335,1008,1816,2533,3085,3365,3556,3729,3874,3999,4094,4188,4265,4341,4420,4499,4568,4638,4690,4733,4777,4817,4856,4893,4932,4961,4989,5011,5026,5034,5043],
    [0,1,335,1008,1816,2542,3094,3374,3566,3738,3892,4018,4113,4212,4292,4369,4445,4510,4577,4647,4699,4742,4787,4834,4875,4912,4950,4988,5016,5036,5044,5052,5062],
    [0,1,335,1008,1816,2552,3103,3384,3575,3747,3911,4036,4131,4230,4320,4392,4454,4519,4587,4656,4708,4751,4796,4843,4889,4930,4969,5009,5044,5055,5062,5071,5080],
    [0,1,335,1008,1816,2561,3113,3393,3584,3757,3920,4055,4149,4249,4343,4402,4463,4528,4596,4666,4718,4760,4805,4852,4898,4944,4987,5027,5065,5073,5081,5089,5098],
    [0,1,335,1008,1816,2570,3122,3402,3593,3766,3929,4073,4168,4263,4352,4411,4473,4538,4605,4675,4727,4770,4815,4861,4907,4954,5002,5046,5083,5092,5099,5108,5117],
    [0,1,335,1008,1816,2588,3140,3421,3612,3784,3948,4100,4189,4281,4371,4429,4491,4556,4623,4693,4745,4788,4833,4880,4926,4972,5020,5070,5117,5129,5136,5145,5154],
    [0,1,335,1008,1816,2607,3159,3439,3630,3803,3966,4119,4208,4300,4389,4448,4509,4574,4642,4712,4764,4807,4851,4898,4944,4991,5039,5088,5135,5160,5173,5181,5191],
    [0,1,335,1008,1816,2625,3177,3457,3649,3821,3984,4137,4226,4318,4407,4466,4528,4593,4660,4730,4782,4825,4870,4917,4963,5009,5057,5106,5153,5178,5204,5218,5227],
    [0,1,335,1008,1816,2644,3196,3476,3667,3840,4003,4155,4245,4336,4426,4485,4546,4611,4679,4748,4800,4843,4888,4935,4981,5027,5076,5125,5172,5197,5222,5249,5264],
    [0,1,335,1008,1816,2662,3214,3494,3686,3858,4021,4174,4263,4355,4444,4503,4565,4630,4697,4767,4819,4862,4907,4954,5000,5046,5094,5143,5190,5215,5241,5267,5295],
    [0,1,335,1008,1816,2681,3232,3513,3704,3876,4040,4192,4282,4373,4463,4521,4583,4648,4716,4785,4837,4880,4925,4972,5018,5064,5112,5162,5209,5233,5259,5286,5313],
    [0,1,335,1008,1816,2692,3251,3531,3722,3895,4058,4211,4300,4392,4481,4540,4602,4667,4734,4804,4856,4899,4944,4991,5037,5083,5131,5180,5227,5252,5278,5304,5331]
  ];
  /* SIM-EIND */
  function opAs(as, v) {
    var n = as.length - 1;
    if (!(v > as[0])) return [0, 0];
    if (v >= as[n]) return [n - 1, 1];
    var i = 0;
    while (as[i + 1] < v) i++;
    return [i, (v - as[i]) / (as[i + 1] - as[i])];
  }
  /* kWh uit de batterij per 1.000 kWh jaarverbruik volgens de simulatie, nog niet geijkt */
  function simBatterij(x, y) {
    var a = opAs(SIM_X, x), b = opAs(SIM_Y, y), T = SIM_BATTERIJ;
    var r0 = T[b[0]][a[0]] + (T[b[0]][a[0] + 1] - T[b[0]][a[0]]) * a[1];
    var r1 = T[b[0] + 1][a[0]] + (T[b[0] + 1][a[0] + 1] - T[b[0] + 1][a[0]]) * a[1];
    return (r0 + (r1 - r0) * b[1]) / 10;
  }
  /* kWh zonnestroom per jaar uit de batterij voor dit huis, geijkt op de meting van CE Delft */
  function zonUitBatterij(L, P, cap) {
    if (!(L > 0) || !(P > 0) || !(cap > 0)) return 0;
    return M.ijk * simBatterij(P / L, cap / L * 1000) * L / 1000;
  }

  function directVanTotaal(totaal, opwek) {
    if (!(opwek > 0) || !(totaal > 0)) return 0;
    return Math.min(opwek, htwAutarkie((opwek / C.htwOpwekPerKwp) / totaal * 1000, 0) * totaal);
  }

  function bereken(invoer, bat) {
    var kabelExtra = Math.max(0, (invoer.kabelafstand || 0) - C.kabelInbegrepen) * C.kabelPrijsPerMeter;
    var investering = bat.prijs + kabelExtra;
    var dyn = !!invoer.dynamisch;
    var L = Math.max(0, invoer.jaarverbruik || 0), P = Math.max(0, invoer.jaaropwek || 0), cap = bat.capaciteit;
    var direct = invoer.directDak != null ? invoer.directDak : directVanTotaal(L, P);
    var terug = Math.max(0, P - direct);
    var handelBeurten = dyn ? M.handelBeurten : 0;

    var somHard = 0, somMet = 0, tv = null, tvMet = null, netto15 = -investering, eerste = null;
    for (var n = 1; n <= 30; n++) {
      var capN = cap * Math.max(0, 1 - M.veroudering * (n - 1));
      var bewaard = Math.min(zonUitBatterij(L, P, capN), terug * M.rendement);
      var opgevangen = bewaard / M.rendement;
      var hard = dyn ? bewaard * M.avondDyn - opgevangen * M.middagDyn : bewaard * M.tariefVast - opgevangen * M.terugVastNetto;
      var handel = handelBeurten * capN * M.handelPerKwh;
      if (n === 1) eerste = { bewaard: bewaard, hard: hard, handel: handel };
      somHard += hard; somMet += hard + handel;
      if (n <= 15) netto15 += hard + handel;
      if (tv === null && hard > 0 && somHard >= investering) tv = n;
      if (tvMet === null && hard + handel > 0 && somMet >= investering) tvMet = n;
    }

    var leenbedrag = Math.min(investering, C.warmtefondsMax);

    return {
      investering: investering,
      besparing: Math.round(eerste.hard),
      handel: Math.round(eerste.handel),
      jaar1: Math.round(eerste.hard),
      jaar1Verwacht: Math.round(eerste.hard + eerste.handel),
      jaar1Gunstig: Math.round(eerste.hard + eerste.handel),
      tv: tv,
      tvVerwacht: tvMet,
      tvGunstig: tvMet,
      /* het getal voor de regel 'binnen vijftien jaar': bij dynamisch met de 100 handelsbeurten, bij vast de harde besparing */
      tvAdvies: tvMet,
      netto15: Math.round(netto15),
      perMaand: leenbedrag / C.warmtefondsLooptijdMaanden,
      bovenMax: investering > C.warmtefondsMax,
      perKwh: Math.round((bat.prijsMetBtw || bat.prijs) / brutoGetal(bat)), /* 8 okt 2026: op bruto, gelijk aan vergelijker, productpagina en offerte (taak 144) */
      bewaardKwh: Math.round(eerste.bewaard),
      zonBeurten: Math.round(eerste.bewaard / cap),
      handelBeurten: handelBeurten,
      /* alleen voor de uitleg onder het advies: meer dan de helft van het overschot gaat nog naar het net, of anderhalf
         keer zoveel opslag levert minder dan 3% extra op */
      overschotGroterDanBatterij: terug > 0 && terug - eerste.bewaard / M.rendement > 0.5 * terug,
      plafondActief: P > 0 && eerste.bewaard > 0 && zonUitBatterij(L, P, cap * 1.5) - eerste.bewaard < 0.03 * eerste.bewaard
    };
  }

  /* 21 okt 2026 (besluit Luc): bij een dynamisch contract rekent de terugverdientijd met de prijs na btw-teruggave.
     Voor de keuze van de maat en het voorbeeldhuis; de calculator en de offerte geven zelf de juiste prijs mee. */
  function metNaBtw(bat) {
    var nb = naBtw(bat.prijs, bat.id + '|' + (bat.fase || '1') + '|' + bat.capaciteit);
    if (!nb || nb.opMaat) return bat;
    var kopie = {};
    for (var k in bat) kopie[k] = bat[k];
    kopie.prijsMetBtw = bat.prijs;
    kopie.prijs = nb.bedrag;
    return kopie;
  }
  function berekenAdvies(invoer, bat) { return bereken(invoer, invoer.dynamisch ? metNaBtw(bat) : bat); }

  /* Zelfvoorzienendheid: welk deel van je jaarverbruik van je eigen dak komt, direct of via de batterij.
     v13 (5 okt 2026, op vraag van Luc): niet meer ons eigen seizoensmodel, dat voor een huis met
     6.500 kWh, 20 panelen en 17,5 kWh 42% naar 85% gaf. Nu de tabel van de Hogeschool HTW Berlin
     (Unabhaengigkeitsrechner, solar.htw-berlin.de; Weniger, Quaschning e.a. 2013/2014), een
     simulatie per minuut over een heel jaar met gemeten verbruiksprofielen. Rijen = bruikbare
     batterij in kWh per 1.000 kWh verbruik, kolommen = zonnepanelen in kWp per 1.000 kWh, beide
     van 0 tot 3 in stappen van 0,0625; waarde = zelfvoorzienend in promille. Voor datzelfde huis:
     32% naar 72%. Controle tegen het artikel: 1 kWp en 1 kWh per 1.000 kWh geeft 56%, zoals daar staat.
     Metingen bij 110 Duitse huishoudens met batterij: mediaan 70% (HTW 2024). */
  var HTW_AUTARKIE = [
    [0,62,107,140,166,188,207,223,238,250,261,270,279,286,293,299,305,310,315,319,323,327,331,335,338,341,344,347,349,352,354,357,359,361,363,365,367,369,370,372,374,375,377,378,379,381,382,383,385],
    [0,64,120,161,193,217,238,255,270,282,292,301,309,316,323,329,335,340,344,349,353,357,360,363,367,370,372,375,378,380,382,385,387,389,391,392,394,396,398,399,401,402,404,405,406,408,409,410,411],
    [0,64,123,171,208,236,258,277,291,303,314,323,331,339,345,351,357,362,367,371,375,379,383,386,389,392,395,398,400,402,405,407,409,411,413,415,416,418,420,421,423,424,426,427,428,430,431,432,433],
    [0,64,124,175,217,249,273,293,308,321,332,341,350,358,364,371,376,381,386,391,395,398,402,405,409,412,414,417,420,422,424,427,429,431,433,434,436,438,439,441,442,444,445,447,448,449,451,452,453],
    [0,64,125,179,223,258,285,306,323,336,348,358,366,374,381,388,393,398,403,408,412,416,420,423,426,429,432,435,437,440,442,444,447,449,451,453,454,456,458,459,461,462,464,465,467,468,469,470,472],
    [0,64,125,181,228,266,295,317,335,349,362,372,381,389,397,403,409,414,419,424,428,432,436,439,443,446,449,452,454,457,459,461,464,466,468,470,472,474,475,477,479,480,482,483,485,486,487,488,490],
    [0,64,125,182,232,272,304,328,347,362,374,386,395,404,411,418,424,429,434,439,443,448,451,455,459,462,465,468,470,473,475,478,480,482,485,487,489,490,492,494,496,497,499,500,502,503,504,506,507],
    [0,64,125,183,235,277,311,337,357,373,387,398,408,417,425,432,438,444,449,454,458,463,467,470,474,477,481,483,486,489,492,494,496,499,501,503,505,507,509,510,512,514,516,517,519,520,522,523,524],
    [0,64,125,184,237,282,318,346,367,384,399,411,421,430,439,446,452,458,464,469,473,477,481,485,489,493,496,499,502,505,507,510,512,515,517,519,521,523,525,527,529,531,532,534,535,537,538,540,541],
    [0,64,125,184,239,286,323,353,376,394,410,423,434,443,452,459,466,472,478,483,488,492,496,500,504,507,511,514,517,520,523,526,528,531,533,535,537,540,542,543,545,547,549,550,552,553,555,556,558],
    [0,64,125,184,240,289,329,360,385,404,421,434,446,456,465,472,479,486,492,497,502,507,511,515,519,522,526,529,533,536,538,541,544,546,549,551,553,555,558,560,561,563,565,567,568,570,571,573,574],
    [0,64,125,184,241,292,333,367,393,414,431,445,457,468,477,485,493,499,506,511,516,521,525,530,534,537,541,544,548,551,554,557,559,562,564,567,569,571,573,576,578,579,581,583,585,586,588,589,591],
    [0,64,125,184,242,294,338,372,401,423,440,456,469,480,490,498,506,513,519,525,530,535,540,544,548,552,556,559,562,566,569,572,575,577,580,582,585,587,589,591,593,595,597,599,601,603,604,606,607],
    [0,64,125,184,242,296,341,378,407,431,450,466,480,492,502,510,518,526,532,538,544,549,554,558,563,567,570,574,577,581,584,587,590,592,595,598,600,603,605,607,609,611,613,615,617,619,620,622,624],
    [0,64,125,184,242,297,345,383,413,439,459,476,491,503,514,523,531,539,545,552,558,563,568,573,577,581,585,589,592,595,598,602,605,608,610,613,615,618,620,623,625,627,629,631,633,634,636,638,639],
    [0,64,125,184,242,298,348,387,419,446,468,485,501,514,525,535,543,551,558,565,571,577,582,587,591,595,599,603,607,610,613,616,619,622,625,628,630,633,635,637,639,642,644,646,648,649,651,653,655],
    [0,64,125,184,242,299,350,391,425,453,476,495,511,524,536,546,555,563,571,578,584,590,595,600,605,609,613,617,620,624,627,630,633,636,639,641,644,647,649,651,653,656,658,660,662,663,665,667,669],
    [0,64,125,184,242,299,352,395,430,459,484,503,520,535,547,558,567,575,583,590,596,602,608,613,618,622,626,630,633,637,640,643,646,649,652,654,657,660,662,664,666,669,671,673,675,676,678,680,682],
    [0,64,125,184,242,299,353,398,435,465,491,512,529,544,557,569,578,586,594,601,608,614,619,625,630,634,638,642,645,649,652,655,658,661,664,666,669,671,674,676,678,681,683,685,687,688,690,692,694],
    [0,64,125,184,242,299,354,401,439,471,497,520,538,553,566,578,588,597,604,612,618,624,630,635,641,645,649,653,656,660,663,666,669,672,675,677,680,683,685,687,690,692,694,696,698,700,702,704,705],
    [0,64,125,184,242,299,355,403,443,476,503,527,546,561,575,586,597,606,614,621,628,634,640,645,651,655,659,663,667,670,673,676,679,682,685,688,691,693,696,698,700,703,705,707,709,711,713,715,716],
    [0,64,125,184,242,299,356,405,447,480,508,533,553,569,582,594,605,614,623,630,637,643,649,655,660,665,669,673,677,680,683,686,689,692,695,698,701,703,706,708,711,713,715,717,719,721,723,725,727],
    [0,64,125,184,242,299,356,407,450,485,513,538,559,575,589,601,612,622,631,638,645,652,658,664,669,674,678,682,686,689,693,696,699,702,705,707,710,713,715,718,720,723,725,727,729,731,733,735,737],
    [0,64,125,184,242,299,356,408,452,488,517,543,564,581,596,608,619,630,638,646,653,660,666,672,677,682,686,691,695,698,702,705,708,711,714,716,719,722,725,727,729,732,734,736,738,740,742,744,746],
    [0,64,125,184,242,299,356,409,454,491,521,547,569,587,601,614,626,636,645,653,661,668,674,680,685,690,694,699,703,706,710,713,716,719,722,725,728,730,733,736,738,740,743,745,747,749,751,753,755],
    [0,64,125,184,242,299,356,410,456,494,525,551,574,592,607,620,632,642,652,660,668,675,682,687,693,697,702,706,710,714,718,721,724,727,730,733,736,738,741,744,746,748,751,753,755,757,759,761,763],
    [0,64,125,184,242,299,356,411,457,496,528,554,578,596,612,625,637,648,658,667,674,682,688,694,699,704,709,713,717,721,725,728,731,735,737,740,743,746,748,751,754,756,758,761,763,765,767,769,771],
    [0,64,125,184,242,299,356,411,459,498,531,558,581,601,617,630,642,653,663,672,680,688,694,700,705,710,715,719,723,727,731,735,738,741,744,747,750,753,755,758,761,763,765,768,770,772,774,776,778],
    [0,64,125,184,242,299,356,411,460,500,534,561,584,605,621,634,647,658,668,677,685,693,699,705,711,716,720,725,729,733,737,741,744,747,750,753,756,759,762,764,767,769,772,774,776,779,781,783,785],
    [0,64,125,184,242,299,356,411,461,501,536,564,587,608,624,638,651,662,672,681,690,697,704,710,716,721,726,730,734,739,743,746,750,753,756,759,762,765,768,770,773,775,778,780,783,785,787,789,791],
    [0,64,125,184,242,299,356,412,462,503,538,567,590,611,627,641,654,666,676,685,693,701,708,714,720,725,730,735,739,743,747,751,755,758,761,764,767,770,773,776,778,781,783,786,788,790,792,795,797],
    [0,64,125,184,242,299,356,412,462,504,540,569,592,613,630,644,657,669,679,688,696,704,711,718,724,729,734,739,744,748,752,755,759,762,766,769,772,775,778,780,783,786,788,790,793,795,797,799,801],
    [0,64,125,184,242,299,356,412,463,506,542,570,594,615,632,647,660,672,682,691,699,707,714,721,727,733,738,743,747,751,755,759,763,766,770,773,776,779,782,785,787,790,792,794,797,799,801,804,806],
    [0,64,125,184,242,299,356,412,463,507,543,572,596,616,634,649,662,674,685,694,702,710,717,724,730,736,741,746,751,755,759,763,766,770,773,776,780,783,786,788,791,793,796,798,800,803,805,807,810],
    [0,64,125,184,242,299,356,412,464,508,544,573,597,618,636,651,664,676,687,696,704,712,719,726,733,739,744,749,754,758,762,766,770,773,776,780,783,786,789,792,794,797,799,801,804,806,808,811,813],
    [0,64,125,184,242,299,356,412,464,509,545,574,599,620,638,653,666,678,689,698,706,714,721,728,735,741,747,752,757,761,765,769,772,776,779,783,786,789,792,794,797,799,802,804,807,809,811,814,816],
    [0,64,125,184,242,299,356,412,464,510,547,576,600,621,640,655,668,680,690,699,708,716,723,730,737,743,749,754,759,763,767,771,775,779,782,785,788,791,794,797,800,802,805,807,810,812,814,817,819],
    [0,64,125,184,242,299,356,412,465,510,548,577,602,623,641,656,669,681,692,701,709,717,725,732,739,745,751,757,761,766,770,774,778,781,784,788,791,794,797,799,802,805,807,810,812,815,817,819,821],
    [0,64,125,184,242,299,356,412,465,511,549,578,603,624,643,658,671,683,693,702,711,719,726,734,741,747,753,759,764,768,772,776,780,783,787,790,793,796,799,802,804,807,810,812,815,817,819,822,824],
    [0,64,125,184,242,299,356,412,465,511,550,579,604,625,644,659,672,684,694,704,712,720,728,735,742,749,755,761,766,770,774,778,782,785,789,792,795,798,801,804,807,809,812,814,817,819,822,824,826],
    [0,64,125,184,242,299,356,413,465,512,551,580,606,627,646,660,673,685,696,705,714,722,730,737,744,750,757,763,768,772,776,780,784,788,791,794,797,800,803,806,809,811,814,817,819,822,824,826,828],
    [0,64,125,184,242,299,356,412,465,513,551,581,607,628,647,662,675,686,697,706,715,723,731,738,745,752,758,764,770,774,778,782,786,789,793,796,799,802,805,808,811,814,816,819,821,824,826,828,830],
    [0,64,125,184,242,299,356,412,465,513,552,582,608,629,648,663,676,687,698,707,716,725,733,740,747,754,760,766,771,776,780,784,788,791,795,798,801,804,807,810,813,816,818,821,823,826,828,830,832],
    [0,64,125,184,242,299,356,412,465,513,553,583,609,630,649,664,677,688,699,709,718,726,734,741,748,755,762,768,773,778,782,786,790,793,796,800,803,806,809,812,815,817,820,822,825,827,830,832,834],
    [0,64,125,184,242,299,356,412,466,514,554,584,610,632,650,665,678,689,700,710,719,727,735,743,750,757,763,769,774,779,784,788,791,795,798,801,805,808,811,814,817,819,822,824,827,829,831,833,836],
    [0,64,125,184,242,299,356,412,466,514,554,585,611,633,651,666,679,690,701,711,720,728,737,744,751,758,765,771,776,781,785,789,793,796,800,803,806,809,812,815,818,821,823,826,828,830,833,835,837],
    [0,64,125,184,242,299,356,412,466,515,555,586,611,633,652,667,680,691,702,712,721,730,738,746,753,760,766,772,777,782,786,790,794,798,801,804,808,811,814,817,820,822,825,827,830,832,834,837,839],
    [0,64,125,184,242,299,356,412,466,515,556,587,612,634,653,668,680,692,703,712,722,731,739,747,754,761,768,773,779,784,788,792,795,799,803,806,809,812,815,818,821,824,826,829,831,833,836,838,840],
    [0,64,125,184,242,299,356,412,466,515,556,588,613,635,654,669,681,693,704,713,723,732,740,748,756,763,769,775,780,785,789,793,797,800,804,807,810,814,817,820,822,825,828,830,832,835,837,839,841]
  ];
  function htwAutarkie(x, y) {
    var s = 0.0625, n = HTW_AUTARKIE.length - 1;
    x = Math.max(0, Math.min(n * s, x)) / s; y = Math.max(0, Math.min(n * s, y)) / s;
    var x0 = Math.min(n - 1, Math.floor(x)), y0 = Math.min(n - 1, Math.floor(y));
    var fx = x - x0, fy = y - y0, T = HTW_AUTARKIE;
    var boven = T[y0][x0] + (T[y0][x0 + 1] - T[y0][x0]) * fx;
    var onder = T[y0 + 1][x0] + (T[y0 + 1][x0 + 1] - T[y0 + 1][x0]) * fx;
    return (boven + (onder - boven) * fy) / 1000;
  }
  function zelfvoorziening(invoer, bat) {
    if (invoer.jaarverbruik <= 0) return null;
    var pv = (invoer.jaaropwek / C.htwOpwekPerKwp) / invoer.jaarverbruik * 1000;
    var zonder = Math.round(100 * htwAutarkie(pv, 0));
    if (!bat) return { zonder: zonder, met: zonder, ruw: zonder };
    /* v21 (23 okt 2026, taak 100, Luc): "altijd 5% onder de uitkomst van HTW Berlin", 5 procentpunt. De grens "hooguit
       twee keer zonder" van 13 okt is eruit: die was een veralgemening door Claude van Lucs voorbeeldhuis (31 naar 62
       procent) en zette elke maat op hetzelfde getal. De tabel van HTW loopt tot 3 kWh opslag per 1.000 kWh; daarboven
       telt de groei uit de natuurkundige simulatie (SIM_BATTERIJ) erbij, zodat ook grote maten een eigen getal houden.
       Getoetst 23 okt 2026: bij 3.500 kWh van het net en 3.990 kWh opwek geeft de simulatie 60 tot 63 procent, de
       tabel 61 tot 63. */
    var rand = (HTW_AUTARKIE.length - 1) * 0.0625;
    var y = bat.capaciteit / invoer.jaarverbruik * 1000;
    var tabel = htwAutarkie(pv, Math.min(y, rand));
    if (y > rand) {
      var x = invoer.jaaropwek / invoer.jaarverbruik;
      tabel += (simBatterij(x, y) - simBatterij(x, rand)) / 1000;
    }
    var ruw = Math.round(1000 * tabel) / 10;   /* voor de keuze tussen sets, zonder de 5 procentpunt */
    var met = Math.round(100 * tabel - 5);
    if (met < zonder) met = zonder;
    return { zonder: zonder, met: met, ruw: ruw };
  }

  /* 21 okt 2026 (taak 272, go Luc): hoeveel kWh van de opwek een huis direct zelf gebruikt. Op de jaarafrekening staat
     alleen de stroom van het net (afname); het directe deel ziet de meter niet. Eerst vast 30% (gemiddelde van Milieu
     Centraal), nu per huis uit dezelfde HTW-tabel als zelfvoorziening(): het directe deel is "zelfvoorzienend zonder
     batterij" maal het totale verbruik, en dat totaal is afname plus dat directe deel. Een paar rekenrondes geven het
     getal waarbij beide kloppen. Een gewoon huis komt rond de 30% uit; veel verbruik met weinig panelen hoger (tot
     zo'n 90%), een groot dak met weinig verbruik lager. Zo komt het percentage met batterij nooit boven wat dak en
     batterij samen kunnen leveren. */
  function directVanDak(afname, opwek) {
    if (!(opwek > 0) || !(afname > 0)) return 0;
    var d = opwek * 0.3;
    for (var i = 0; i < 40; i++) {
      var totaal = afname + d;
      d = htwAutarkie((opwek / C.htwOpwekPerKwp) / totaal * 1000, 0) * totaal;
    }
    if (!(d >= 0)) return 0;
    return Math.round(Math.min(d, opwek) / 10) * 10;
  }

  /* Adviescapaciteit (v4): wat je huis per nacht opneemt (verbruik x 60% / 365, gecorrigeerd voor laadverlies),
     begrensd door wat je dak op een zomerdag overhoudt. Blijft bestaan voor scripts die hem gebruiken;
     de keuze zelf loopt sinds v10 via adviesBand. */
  function adviesCapaciteit(invoer) {
    if (invoer.jaarverbruik <= 0 || invoer.jaaropwek <= 0) return null;
    var nachtLading = invoer.jaarverbruik * C.aandeelNachtverbruik / 365 / C.rendement;
    var zomerOverschotDag = invoer.jaaropwek * C.aandeelOverschot * 0.38 / 91.25;
    var advies = invoer.dynamisch ? nachtLading : Math.min(nachtLading, zomerOverschotDag);
    return Math.max(5, Math.round(advies));
  }

  /* v10, laag twee: de maat als bandbreedte in plaats van een los getal.
     Onder = 1,0 kWh per 1.000 kWh jaarverbruik (het echte avond- en nachtverbruik).
     Boven = 1,5 per 1.000 bij een vast contract (HTW-bovengrens), begrensd door het zomeroverschot
     van het dak; 2,0 per 1.000 bij dynamisch (handel vult de extra capaciteit).
     Bij de voorkeur "zo zelfvoorzienend mogelijk" mag de bovengrens 30% ruimer. */
  function adviesBand(invoer, voorkeuren) {
    if (invoer.jaarverbruik <= 0) return null;
    var per1000 = invoer.jaarverbruik / 1000;
    var onder = per1000 * C.bandOnderPer1000;
    var boven;
    if (invoer.dynamisch) {
      boven = per1000 * C.bandBovenDynPer1000;
    } else {
      boven = per1000 * C.bandBovenVastPer1000;
      var zomerDag = invoer.jaaropwek * C.aandeelOverschot * 0.38 / 91.25;
      if (zomerDag > 0 && zomerDag < boven) boven = Math.max(onder, zomerDag);
    }
    if (voorkeuren && voorkeuren.indexOf('zelf') > -1) boven *= 1.3;
    if (boven < onder) boven = onder;
    /* v15 (taak 156): extra verbruik van verbruikers die er nog komen (invoer.extraVerbruik, al meegeteld in
       jaarverbruik). Bij een dynamisch contract groeit de band gewoon mee. Bij een vast contract laadt de batterij
       alleen van het dak, dus groeit hij hooguit tot de grens van HTW Berlin, 1,5 kWh per kWp; nooit kleiner dan
       zonder die verbruikers. */
    var begrensd = false;
    if (invoer.extraVerbruik > 0 && !invoer.dynamisch) {
      var zonder = adviesBand({ jaarverbruik: Math.max(1, invoer.jaarverbruik - invoer.extraVerbruik), jaaropwek: invoer.jaaropwek, dynamisch: false }, voorkeuren);
      var grens = C.htwMaxPerKwp * (invoer.jaaropwek > 0 ? invoer.jaaropwek / C.opwekPerKwp : 0);
      var o2 = Math.max(zonder.onder, Math.min(onder, grens)), b2 = Math.max(zonder.boven, Math.min(boven, grens));
      begrensd = o2 < onder - 0.01 || b2 < boven - 0.01;
      onder = o2; boven = Math.max(b2, o2);
    }
    return { onder: onder, boven: boven, begrensd: begrensd, vanTekst: Math.max(1, Math.round(onder)), totTekst: Math.max(Math.round(boven), Math.max(1, Math.round(onder))) };
  }

  /* Oordeel over een maat tegenover de band, met 10% speling op beide grenzen: een maat die een
     fractie boven de bovengrens zit is geen andere categorie batterij. */
  function maatOordeel(cap, band) {
    if (!band) return 'past';
    if (cap < band.onder * 0.9 - 0.01) return 'krap';
    if (cap <= band.boven * 1.1 + 0.01) return 'past';
    if (cap <= band.boven * 1.5) return 'ruim';
    return 'te-groot';
  }

  /* v10: kies binnen één merk de maat. Eerst alle maten die in de band vallen; daaruit de maat met
     het beste geld over vijftien jaar (of, bij de voorkeur zelfvoorzienend, de hoogste
     zelfvoorzienendheid). Valt geen enkele maat in de band, dan de maat die er het dichtst bij ligt. */
  function kiesMaat(bat, fase, band, invoer, voorkeuren, ruimerToegestaan) {
    var f = fase === '3' ? '3' : '1';
    var lijst = (bat.fasen && bat.fasen[f]) || bat;
    var caps = lijst.capaciteiten;
    var inBand = [];
    for (var i = 0; i < caps.length; i++) {
      if (band && caps[i] >= band.onder * 0.9 - 0.01 && caps[i] <= band.boven * 1.1 + 0.01) inBand.push(i);
    }
    var keuze;
    if (inBand.length === 0) {
      /* niets past: de maat die het dichtst bij de band ligt (of bij het bandmidden) */
      var midden = band ? (band.onder + band.boven) / 2 : caps[0];
      keuze = 0;
      var beste = Math.abs(caps[0] - midden);
      for (var n = 1; n < caps.length; n++) {
        if (Math.abs(caps[n] - midden) < beste - 0.001) { beste = Math.abs(caps[n] - midden); keuze = n; }
      }
    } else {
      keuze = inBand[0];
      var besteScore = null, scores = [];
      var opZelf = voorkeuren && voorkeuren.indexOf('zelf') > -1;
      for (var j = 0; j < inBand.length; j++) {
        var kand = maat(bat, f, inBand[j]);
        var score = opZelf
          ? (zelfvoorziening(invoer, kand) || { ruw: 0 }).ruw * 100000 + berekenAdvies(invoer, kand).netto15
          : berekenAdvies(invoer, kand).netto15;
        scores.push(score);
        if (besteScore === null || score > besteScore) { besteScore = score; keuze = inBand[j]; }
      }
      /* 21 okt 2026, keuze Luc (taak 270 punt 2): ligt de opbrengst over 15 jaar van een grotere maat minder dan 5%
         onder die van de beste maat, dan de grotere maat. Past bij zijn besluit van 8 okt dat ruim adviseren prima is. */
      if (!opZelf && besteScore > 0) {
        for (var q = 0; q < inBand.length; q++) {
          if (caps[inBand[q]] > caps[keuze] && scores[q] >= besteScore * 0.95) keuze = inBand[q];
        }
      }
    }
    /* v11 (4 okt 2026): verdient de beste maat binnen de band zich niet binnen vijftien jaar terug,
       kijk dan ook naar de maten die ruimer zijn, tot anderhalf keer de bovengrens. Verdient een
       daarvan zich wel terug, dan is dat het eerlijkere advies dan een te kleine set die niet uitkomt.
       Gevonden bij FoxESS: de 5,2 kWh past bij een klein huis maar verdient zich nooit terug, de
       10,4 kWh wel. */
    if (band) {
      var gekozen = berekenAdvies(invoer, maat(bat, f, keuze));
      /* 23 okt 2026 (taak 100): verdient een andere maat binnen de band zich wel terug, dan die, met het meeste geld over
         15 jaar; pas als geen enkele maat in de band uitkomt, mag het advies ruimer (regel van 4 okt). Zonder dit sprong de
         voorkeur "zelfvoorzienend" naar een maat buiten de band terwijl een maat in de band zich terugverdiende. */
      if (gekozen.tvAdvies === null || gekozen.tvAdvies > 15) {
        var inBandUit = null, inBandGeld = null;
        for (var b2 = 0; b2 < inBand.length; b2++) {
          var resB = berekenAdvies(invoer, maat(bat, f, inBand[b2]));
          if (resB.tvAdvies !== null && resB.tvAdvies <= 15 && resB.jaar1Verwacht > 0 && (inBandGeld === null || resB.netto15 > inBandGeld)) { inBandGeld = resB.netto15; inBandUit = inBand[b2]; }
        }
        if (inBandUit !== null) { keuze = inBandUit; gekozen = berekenAdvies(invoer, maat(bat, f, keuze)); }
      }
      if (gekozen.tvAdvies === null || gekozen.tvAdvies > 15) {
        var beterIndex = null, beterGeld = gekozen.netto15;
        for (var r = 0; r < caps.length; r++) {
          if (caps[r] <= caps[keuze] || caps[r] > band.boven * 1.5 + 0.01) continue;
          var res = berekenAdvies(invoer, maat(bat, f, r));
          if (res.tvAdvies !== null && res.tvAdvies <= 15 && res.netto15 > beterGeld) { beterGeld = res.netto15; beterIndex = r; }
        }
        /* v14 (9 okt 2026, taak 171; Luc 8 okt: "je kunt nooit echt een te grote batterij hebben"):
           verdient ook binnen anderhalf keer de bovengrens geen maat zich terug, neem dan de kleinste
           grotere maat die dat wel doet. Zonder deze regel kreeg een klein huis "nu nog niet" terwijl
           FoxESS 11,52 kWh zich er binnen vijftien jaar terugverdient. De kaart zegt eerlijk dat hij ruim is.
           Alleen als adviseer() anders op "nu nog niet" uitkomt (ruimerToegestaan); anders sprong een
           duurder merk naar een veel grotere maat en won het op een paar euro meer opbrengst. */
        if (beterIndex === null && ruimerToegestaan) {
          for (var g = 0; g < caps.length; g++) {
            if (caps[g] <= caps[keuze]) continue;
            var resG = berekenAdvies(invoer, maat(bat, f, g));
            if (resG.tvAdvies !== null && resG.tvAdvies <= 15 && resG.jaar1Verwacht > 0) { beterIndex = g; break; }
          }
          /* geen grotere maat die uitkomt: dan een kleinere die dat wel doet (de kaart noemt hem krap) */
          if (beterIndex === null) {
            for (var k = caps.length - 1; k >= 0; k--) {
              if (caps[k] >= caps[keuze]) continue;
              var resK = berekenAdvies(invoer, maat(bat, f, k));
              if (resK.tvAdvies !== null && resK.tvAdvies <= 15 && resK.jaar1Verwacht > 0) { beterIndex = k; break; }
            }
          }
        }
        if (beterIndex !== null) keuze = beterIndex;
      }
    }
    return maat(bat, f, keuze);
  }

  /* v10, laag een en drie: sluit uit wat niet kan, geef punten op wat de klant belangrijk vindt,
     en laat bij een gelijkspel de voorrang (vr) beslissen. Geeft de rijen terug, winnaar eerst,
     elk met labels, oordeel en eventueel de reden van uitsluiting. */
  function adviseer(invoer, fase, voorkeuren, band, ruimer) {
    var f = fase === '3' ? '3' : '1';
    var vk = voorkeuren || [];
    var rijen = BATTERIJEN.map(function (b) {
      var cfg = kiesMaat(b, f, band, invoer, vk, ruimer);
      var eigen = EIGEN[b.id] || {};
      var uitgesloten = null;
      if (vk.indexOf('noodstroom') > -1 && eigen.noodstroom && eigen.noodstroom[f] === 'geen') {
        uitgesloten = 'Geen noodstroomaansluiting in deze uitvoering';
      }
      /* 12 okt 2026, besluit Luc: het losse stuurkastje (Eniris) wordt niet meer aangeboden; de wens "meesturen"
         is uit het formulier en sluit niets meer uit. */
      return {
        bat: cfg,
        eigen: eigen,
        res: berekenAdvies(invoer, cfg),
        zv: zelfvoorziening(invoer, cfg),
        oordeel: maatOordeel(cfg.capaciteit, band),
        uitgesloten: uitgesloten,
        punten: 0,
        redenen: []
      };
    });

    var mee = rijen.filter(function (r) { return !r.uitgesloten; });
    var rangpunten = function (lijst, waarde, puntenPerRang, reden) {
      var volgorde = lijst.slice().sort(function (a, b) { return waarde(b) - waarde(a); });
      volgorde.forEach(function (r, i) {
        var p = puntenPerRang[i] || 0;
        r.punten += p;
        if (i === 0 && p > 0 && reden) r.redenen.push(reden);
      });
    };

    /* v11 (4 okt 2026): een maat die bij het huis past krijgt evenveel punten als het beste rendement.
       Zonder deze regel won een ruimere set met een langere terugverdientijd, alleen omdat een grotere
       batterij meer handelswinst maakt; dat is geen eerlijk advies voor een huis van die grootte. */
    mee.forEach(function (r) { if (r.oordeel === 'past') r.punten += 2; });
    /* v12 (8 okt 2026, taak 149, Luc: "je kunt nooit echt een te grote batterij hebben"): een ruimere maat
       die even duur of goedkoper is EN de klant meer oplevert dan een maat die past, krijgt dezelfde
       2 punten. Zo wint nooit een kleinere, duurdere set die minder oplevert alleen op de maat. */
    mee.forEach(function (r) {
      if (r.oordeel !== 'ruim' && r.oordeel !== 'te-groot') return;
      var beterDanPassend = mee.some(function (p) {
        return p !== r && p.oordeel === 'past' && r.res.investering <= p.res.investering && r.res.netto15 > p.res.netto15;
      });
      if (beterDanPassend) { r.punten += 2; r.redenen.push('ruimer, maar niet duurder en levert je meer op'); }
    });

    /* Geld telt altijd; kiest de klant "snel terugverdienen", dan telt het dubbel. */
    var geldGewicht = vk.indexOf('rendement') > -1 ? 2 : 1;
    rangpunten(mee, function (r) { return r.res.netto15; }, [2 * geldGewicht, 1 * geldGewicht, 0], 'het meeste geld over na vijftien jaar');
    if (vk.indexOf('zelf') > -1) {
      rangpunten(mee, function (r) { return r.zv ? r.zv.ruw : 0; }, [2, 1, 0], 'maakt je huis het meest zelfvoorzienend');
    }
    if (vk.indexOf('noodstroom') > -1) {
      /* Een noodstroomuitgang in de omvormer zelf telt zwaarder dan een los kastje dat er nog bij moet */
      mee.forEach(function (r) {
        var stand = (r.eigen.noodstroom || {})[f] || 'geen';
        var p = stand === 'ingebouwd' ? 2 : (stand === 'los' ? 1 : 0);
        r.punten += p;
        if (stand === 'ingebouwd') r.redenen.push('de noodstroomuitgang zit in de omvormer zelf');
      });
    }
    if (vk.indexOf('eenmerk') > -1) {
      mee.forEach(function (r) {
        if (r.eigen.eenMerk) { r.punten += 2; r.redenen.push('batterij, omvormer en app van één merk'); }
      });
    }
    if (vk.indexOf('uitbreiden') > -1) {
      rangpunten(mee, function (r) { return ((r.eigen.groeiTot || {})[f] || r.bat.capaciteit) - r.bat.capaciteit; }, [2, 1, 0], 'de meeste ruimte om later uit te breiden');
    }

    /* Sorteren: punten, en bij gelijke punten de voorrang (besluit Luc 3 okt 2026), maar alleen als
       de systemen voor de klant even goed zijn: minder dan 5% van de investering verschil in geld
       over vijftien jaar. Is het verschil groter, dan wint wat de klant overhoudt (4 okt 2026). */
    rijen.sort(function (a, b) {
      if (!!a.uitgesloten !== !!b.uitgesloten) return a.uitgesloten ? 1 : -1;
      if (b.punten !== a.punten) return b.punten - a.punten;
      var drempel = 0.05 * Math.max(a.res.investering, b.res.investering);
      if (Math.abs(a.res.netto15 - b.res.netto15) > drempel) return b.res.netto15 - a.res.netto15;
      if (a.bat.vr !== b.bat.vr) return a.bat.vr - b.bat.vr;
      return b.res.netto15 - a.res.netto15;
    });

    /* Bijna-gelijkspel op geld: liggen de nummers een en twee binnen 5% van de investering van
       elkaar, scoren ze op alle gekozen voorkeuren gelijk, en heeft nummer twee voorrang, dan
       wisselen ze. De klant krijgt een systeem dat even goed past; nooit een slechter passend
       systeem omdat het ons meer oplevert. */
    if (rijen.length > 1 && !rijen[0].uitgesloten && !rijen[1].uitgesloten) {
      var a = rijen[0], b = rijen[1];
      var geldA = a.res.netto15, geldB = b.res.netto15;
      var puntenZonderGeldA = a.punten, puntenZonderGeldB = b.punten;
      /* trek de geldpunten eraf: wie hoger in geld staat kreeg 2x gewicht, de ander 1x */
      if (geldA >= geldB) { puntenZonderGeldA -= 2 * geldGewicht; puntenZonderGeldB -= 1 * geldGewicht; }
      else { puntenZonderGeldB -= 2 * geldGewicht; puntenZonderGeldA -= 1 * geldGewicht; }
      var bijnaGelijk = Math.abs(geldA - geldB) <= 0.05 * Math.max(a.res.investering, b.res.investering);
      if (bijnaGelijk && puntenZonderGeldA === puntenZonderGeldB && b.bat.vr < a.bat.vr) {
        rijen[0] = b; rijen[1] = a;
        rijen[0].redenen = rijen[0].redenen.length ? rijen[0].redenen : ['vrijwel hetzelfde rendement als de beste'];
      }
    }
    /* v14 (9 okt 2026, taak 171): verdient de winnaar zich niet binnen vijftien jaar terug, dan wordt
       eerst opnieuw gerekend met ruimere maten (hieronder). Komt daar de winnaar nog steeds niet uit
       en een ander systeem dat bij de wensen past wel, dan gaat dat andere systeem voor. Anders kreeg
       de klant "nu nog niet" terwijl er een set was die wel uitkomt. */
    var komtUit = function (r) { return !r.uitgesloten && r.res.jaar1Verwacht > 0 && r.res.tvAdvies !== null && r.res.tvAdvies <= 15; };
    if (ruimer && rijen.length > 1 && !rijen[0].uitgesloten && !komtUit(rijen[0])) {
      for (var u = 1; u < rijen.length; u++) {
        if (komtUit(rijen[u])) {
          var winnaar = rijen.splice(u, 1)[0];
          if (!winnaar.redenen.length) winnaar.redenen = ['verdient zich als enige binnen vijftien jaar terug'];
          rijen.unshift(winnaar);
          break;
        }
      }
    }
    /* v14: komt geen enkel systeem binnen vijftien jaar uit, reken dan opnieuw met ruimere maten
       (zie kiesMaat). Levert dat een systeem op dat wel uitkomt, dan is dat het advies. */
    if (!ruimer && !rijen[0].uitgesloten && !komtUit(rijen[0])) {
      var ruimerRijen = adviseer(invoer, fase, voorkeuren, band, true);
      if (komtUit(ruimerRijen[0])) return ruimerRijen;
    }
    return rijen;
  }

  /* v11 (4 okt 2026, opdracht Luc): de terugverdientijd per set, voor de klant bij wie die maat
     precies past. Eén bron voor de rekenhulp, de configurator, het overzicht in pdf en de offertes.
     Het profiel: een jaarverbruik waarbij de batterij 1,5 kWh opslag per 1.000 kWh verbruik is,
     het midden van onze bandbreedte bij een dynamisch contract, en zonnepanelen die per jaar
     evenveel opwekken als het huis verbruikt. Gerekend met een dynamisch en met een vast contract. */
  var REF = { opslagPer1000: 1.5 };
  function referentie(bat, fase, index) {
    var f = fase === '3' ? '3' : '1';
    var m = maat(bat, f, index);
    var verbruik = Math.round(m.capaciteit / REF.opslagPer1000 * 10) * 100;
    var invoer = function (dyn) { return { jaarverbruik: verbruik, jaaropwek: verbruik, dynamisch: dyn, kabelafstand: 0 }; };
    /* 21 okt 2026 (taak 271): dynamisch met de prijs na btw-teruggave; dynamischMetBtw voor de kolom met btw in de offerte */
    return { bat: m, verbruik: verbruik, dynamisch: bereken(invoer(true), metNaBtw(m)), dynamischMetBtw: bereken(invoer(true), m), vast: bereken(invoer(false), m) };
  }

  /* v11: de offerte per set als pdf, opgeslagen bij Shopify. Geschreven door
     hulpscripts/prijzen-v9/offertes-voor-site.js; niet met de hand wijzigen. Sleutel: merk|fase|kWh. */
  var OFFERTES = {
    /* OFFERTES-BEGIN */
    'overzicht': 'https://cdn.shopify.com/s/files/1/1093/9583/7267/files/terugverdientijd-per-systeem-v9_a1d94051-7e2e-4ecc-a309-f5dba1a2d5bd.pdf?v=1792750063',
    'foxess-ep-serie|1|5.2': 'https://cdn.shopify.com/s/files/1/1093/9583/7267/files/offerte-foxess-5-2kwh-1fase-v9_cfd53db8-45ee-4381-bf07-cfe94b2134b0.pdf?v=1792750075',
    'foxess-ep-serie|1|10.4': 'https://cdn.shopify.com/s/files/1/1093/9583/7267/files/offerte-foxess-10-4kwh-1fase-v9_9680fd99-d022-4973-bace-93c0173fe3e4.pdf?v=1792750094',
    'foxess-ep-serie|1|15.6': 'https://cdn.shopify.com/s/files/1/1093/9583/7267/files/offerte-foxess-15-6kwh-1fase-v9_060e819b-2444-4ee9-8a8f-b4cdc9ef2da6.pdf?v=1792750109',
    'foxess-ep-serie|1|20.7': 'https://cdn.shopify.com/s/files/1/1093/9583/7267/files/offerte-foxess-20-7kwh-1fase-v9_1fac5407-7839-4c3e-974e-23b2e4a8e95e.pdf?v=1792750120',
    'foxess-ep-serie|1|31.1': 'https://cdn.shopify.com/s/files/1/1093/9583/7267/files/offerte-foxess-31-1kwh-1fase-v9_ee968d22-b57d-4161-abe1-be1183647844.pdf?v=1792750134',
    'foxess-ep-serie|3|5.2': 'https://cdn.shopify.com/s/files/1/1093/9583/7267/files/offerte-foxess-5-2kwh-3fase-v9_4b6ccd70-85d5-4cff-aa70-ba3334a28d5d.pdf?v=1792750150',
    'foxess-ep-serie|3|10.4': 'https://cdn.shopify.com/s/files/1/1093/9583/7267/files/offerte-foxess-10-4kwh-3fase-v9_66ac7980-890d-490c-b704-8b31e50f25cc.pdf?v=1792750160',
    'foxess-ep-serie|3|15.6': 'https://cdn.shopify.com/s/files/1/1093/9583/7267/files/offerte-foxess-15-6kwh-3fase-v9_b3e49101-3f79-46f0-9436-60f38252d183.pdf?v=1792750172',
    'foxess-ep-serie|3|20.7': 'https://cdn.shopify.com/s/files/1/1093/9583/7267/files/offerte-foxess-20-7kwh-3fase-v9_80f62cb5-7121-480f-b76b-a8e4719bb10e.pdf?v=1792750182',
    'foxess-ep-serie|3|31.1': 'https://cdn.shopify.com/s/files/1/1093/9583/7267/files/offerte-foxess-31-1kwh-3fase-v9_137e94e2-97c6-4a79-ac43-3e50a750abce.pdf?v=1792750201',
    'foxess-ep-serie|3|41.5': 'https://cdn.shopify.com/s/files/1/1093/9583/7267/files/offerte-foxess-41-5kwh-3fase-v9_7749050e-a52d-4b34-a674-1a34b50e385a.pdf?v=1792750212',
    'sigenergy-sigenstor|1|8.8': 'https://cdn.shopify.com/s/files/1/1093/9583/7267/files/offerte-sigenergy-8-8kwh-1fase-v9_6cdcc600-6dbe-46b2-a8d8-07fe3d3d001f.pdf?v=1792750221',
    'sigenergy-sigenstor|1|17.5': 'https://cdn.shopify.com/s/files/1/1093/9583/7267/files/offerte-sigenergy-17-5kwh-1fase-v9_90fb64a4-6bf8-4ac8-9072-4174fac33545.pdf?v=1792750229',
    'sigenergy-sigenstor|1|26.3': 'https://cdn.shopify.com/s/files/1/1093/9583/7267/files/offerte-sigenergy-26-3kwh-1fase-v9_774dea3a-8cf3-4515-a18f-71926304de42.pdf?v=1792750239',
    'sigenergy-sigenstor|3|8.8': 'https://cdn.shopify.com/s/files/1/1093/9583/7267/files/offerte-sigenergy-8-8kwh-3fase-v9_960328a6-e134-4ac7-8577-4662e49d28f9.pdf?v=1792750255',
    'sigenergy-sigenstor|3|17.5': 'https://cdn.shopify.com/s/files/1/1093/9583/7267/files/offerte-sigenergy-17-5kwh-3fase-v9_d44b7b02-e505-448d-acd6-128040aaf2f9.pdf?v=1792750266',
    'sigenergy-sigenstor|3|26.3': 'https://cdn.shopify.com/s/files/1/1093/9583/7267/files/offerte-sigenergy-26-3kwh-3fase-v9_ab221c5b-d351-4731-a4f5-f91f9246bdbb.pdf?v=1792750274',
    'sigenergy-sigenstor|3|35': 'https://cdn.shopify.com/s/files/1/1093/9583/7267/files/offerte-sigenergy-35kwh-3fase-v9_1fc1fabb-0364-4c84-8249-0a5f93678efb.pdf?v=1792750283',
    'sigenergy-sigenstor|3|43.8': 'https://cdn.shopify.com/s/files/1/1093/9583/7267/files/offerte-sigenergy-43-8kwh-3fase-v9_28275c50-49f9-44a2-8eba-4b588689b102.pdf?v=1792750291',
    'sigenergy-sigenstor|3|52.6': 'https://cdn.shopify.com/s/files/1/1093/9583/7267/files/offerte-sigenergy-52-6kwh-3fase-v9_f28e0559-fd20-46bc-8561-b2b65ae8af33.pdf?v=1792750303'
    /* OFFERTES-EIND */
  };

  /* PRIJS NA BTW-TERUGGAVE, besluit Luc 6 okt 2026: de echte eindprijs. De klant krijgt alle btw
     terug en draagt daarna ongeveer 15 euro per kWh batterijcapaciteit af; die afdracht tellen we
     zichtbaar mee. Bron: De Centrale (btw-zonnepanelen.nl) en Zonneplan, gelezen 6 okt 2026; een
     schatting van hen, geen regel van de Belastingdienst. Gerekend met de bruto capaciteit, zodat we
     nooit een te gunstig bedrag tonen. Is de btw op de factuur meer dan 2.495 euro, dan betaal je
     volgens De Centrale ook de vier jaar daarna btw over de opbrengst; daar tonen we geen bedrag maar
     rekenen we persoonlijk door. Het tarief van De Centrale betalen wij (besluit Luc), dus dat zit er
     niet in. Bruto capaciteit per set: blok NABTW, geschreven door hulpscripts/prijzen-v9/na-btw-bijwerken.js
     uit prijslijst.json; dezelfde gegevens staan in snippets/bv-tweeprijs.liquid. */
  var NABTW = {
    /* NABTW-BEGIN */
    'foxess-ep-serie|1|5.2': 5.76,
    'foxess-ep-serie|1|10.4': 11.52,
    'foxess-ep-serie|1|15.6': 17.28,
    'foxess-ep-serie|1|20.7': 23.04,
    'foxess-ep-serie|1|31.1': 34.56,
    'foxess-ep-serie|3|5.2': 5.76,
    'foxess-ep-serie|3|10.4': 11.52,
    'foxess-ep-serie|3|15.6': 17.28,
    'foxess-ep-serie|3|20.7': 23.04,
    'foxess-ep-serie|3|31.1': 34.56,
    'foxess-ep-serie|3|41.5': 46.08,
    'sigenergy-sigenstor|1|8.8': 9.04,
    'sigenergy-sigenstor|1|17.5': 18.08,
    'sigenergy-sigenstor|1|26.3': 27.12,
    'sigenergy-sigenstor|3|8.8': 9.04,
    'sigenergy-sigenstor|3|17.5': 18.08,
    'sigenergy-sigenstor|3|26.3': 27.12,
    'sigenergy-sigenstor|3|35': 36.16,
    'sigenergy-sigenstor|3|43.8': 45.2,
    'sigenergy-sigenstor|3|52.6': 54.24
    /* NABTW-EIND */
  };
  var BTW_AFDRACHT_PER_KWH = 15;
  var BTW_GRENS = 2495;
  /* 9 okt 2026 (taak 171 punt 9, regel uit taak 02): is de btw op de factuur 2.495 euro of meer, dan
     geldt de kleineondernemersregeling niet en draag je af in het jaar van aankoop en de vier jaar
     daarna, ongeveer 15 euro per kWh per jaar (brochure De Centrale: "Is de btw op de aanschaf van de
     thuisbatterij € 2.495 of meer?" en "in de jaren erna btw af te dragen"; vier jaar uit de
     afspraakmail van 8 okt). Dus vijf keer de afdracht, en een bedrag in plaats van "op maat". */
  var BTW_JAREN_BOVEN_GRENS = 5;
  function naBtw(prijs, sleutel) {
    var bruto = NABTW[sleutel];
    if (!bruto || !(prijs > 0)) return null;
    var lang = prijs - prijs / 1.21 >= BTW_GRENS;
    var afdracht = Math.round(BTW_AFDRACHT_PER_KWH * bruto * (lang ? BTW_JAREN_BOVEN_GRENS : 1));
    return { opMaat: false, lang: lang, afdracht: afdracht, bedrag: Math.round(prijs / 1.21) + afdracht };
  }
  /* Het rechtervak van het prijsblok (richting B), voor rekenhulp en configurator */
  function naBtwVak(prijs, sleutel, alleenDynamisch) {
    var n = naBtw(prijs, sleutel);
    if (!n) return '';
    /* 13 okt 2026, besluit Luc (taak 164): bij een vast contract blijven beide prijzen staan, met deze regel onder het bedrag */
    /* 19 okt 2026, opdracht Gianni punt 2, go Luc: bij een vast contract is de prijs inclusief btw het grote getal (links,
       "Jouw prijs"); rechts klein wat het met een dynamisch contract kost. Bedragen ongewijzigd. */
    var lab = alleenDynamisch ? 'Met een dynamisch contract' : 'Na btw-teruggave';
    if (n.opMaat) return '<div class="na"><span class="lab">' + lab + '</span><span class="bedrag op-maat">Op maat</span>' +
      '<span class="onder">bij deze maat rekenen we het persoonlijk voor je door</span><span class="onder"><a href="/pages/btw-thuisbatterij">Zo werkt het</a></span></div>';
    return '<div class="na"><span class="lab">' + lab + '</span><span class="bedrag">' + euro(n.bedrag) + '</span>' +
      /* 15 okt 2026, besluit Luc: "inclusief installatie" en direct daaronder "Zo werkt het"; de afdracht zit nog in het bedrag */
      '<span class="onder">' + (alleenDynamisch ? 'haal je de btw terug en betaal je dit bedrag.' : 'inclusief installatie') + '</span><span class="onder"><a href="/pages/btw-thuisbatterij">Zo werkt het</a></span></div>';
  }

  function euro(n) {
    return '€ ' + Math.round(n).toLocaleString('nl-NL');
  }

  /* Bereik van twee bedragen; gelijk afgerond = één bedrag tonen */
  function bereik(a, b, scheiding) {
    if (Math.round(a) === Math.round(b)) return euro(a);
    return euro(a) + (scheiding || ' tot ') + euro(b);
  }

  /* Terugverdientijd als bereik, altijd van snelst naar langzaamst */
  /* 6 okt 2026, besluit Luc: de bezoeker ziet de bruto opslag zoals de batterij heet (11,52 kWh), uit NABTW;
     de netto capaciteit blijft de sleutel en de basis van alle berekeningen. */
  function brutoGetal(bat) {
    return NABTW[bat.id + '|' + (bat.fase || '1') + '|' + bat.capaciteit] || bat.capaciteit;
  }
  function brutoTekst(bat) {
    var b = brutoGetal(bat);
    return (Math.round(b * 100) / 100).toFixed(2).replace('.', ',');   /* 16 okt 2026: 45,20, niet 45,2 */
  }

  function tvTekst(res, kort) {
    var snel = res.tvVerwacht, traag = res.tv;
    if (snel && traag && snel !== traag) return snel + (kort ? '-' : ' tot ') + traag + (kort ? ' jr' : ' jaar');
    /* 21 okt 2026, taak 271: komt alleen het getal met handel binnen 30 jaar, dan niet doen alsof dat het hele verhaal is */
    if (snel && !traag && res.jaar1 !== res.jaar1Verwacht) return snel + (kort ? '-30+ jr' : ' tot meer dan 30 jaar');
    var een = traag || snel;
    return een ? een + (kort ? ' jr' : ' jaar') : (kort ? '30+ jr' : 'meer dan 30 jaar');
  }

  var OORDEEL_TEKST = {
    past: 'Past bij jouw verbruik',
    ruim: 'Ruimer dan nodig',
    'te-groot': 'Waarschijnlijk te groot voor jouw huis',
    krap: 'Aan de krappe kant'
  };

  function init() {
    var wortel = document.querySelector('[data-bv-calculator]');
    if (!wortel) return;

    var velden = {
      verbruik: wortel.querySelector('[name="verbruik"]'),
      panelen: wortel.querySelector('[name="panelen"]'),
      wp: wortel.querySelector('[name="wp"]'),
      leeftijd: wortel.querySelector('[name="leeftijd"]'),
      contract: wortel.querySelector('[name="contract"]'),
      kabel: wortel.querySelector('[name="kabel"]'),
      aansluiting: wortel.querySelector('[name="aansluiting"]'),
      omvormer: wortel.querySelector('[name="omvormer"]')
    };
    var zwaarVelden = wortel.querySelectorAll('[name="zwaar"]');
    var voorkeurVelden = wortel.querySelectorAll('[name="voorkeur"]');
    var opwekRegel = wortel.querySelector('[data-bv-opwek]');

    function ingevuld(el) { return el && String(el.value).trim() !== ''; }
    var uitvoer = wortel.querySelector('[data-bv-uitkomst]');
    var samenvatting = wortel.querySelector('[data-bv-samenvatting]');
    var laatsteBerekening = null;
    /* 8 okt 2026, Luc: het advies komt pas als de klant op "Bereken mijn batterij" klikt, nadat hij alle
       vragen heeft gezien. Daarna rekent hij bij elke wijziging direct mee (zichtbare reactie, regressie 3). */
    var berekend = false;
    var berekenKnop = wortel.querySelector('[data-bv-bereken]');
    var flitsTimer = null;

    /* De batterij-mascotte van Batterijenvoordeel (bewust naamloos; knippert af en toe via CSS).
       Sinds 23 aug 2026 met twee armen en witte handschoentjes; zelfde tekening als snippets/bv-batty.liquid.
       wijs: 'omlaag' laat beide handjes naar beneden wijzen; zonder wijs juicht hij. */
    function mascotte(maat, wijs) {
      var armen, handen;
      if (wijs === 'omlaag') {
        armen = '<path d="M50 36q8 2 8.5 8.5" stroke="#0f9d63" stroke-width="5.5" fill="none" stroke-linecap="round"/>' +
          '<path d="M14 37q-5.5 2 -5.5 8" stroke="#0f9d63" stroke-width="5.5" fill="none" stroke-linecap="round"/>';
        handen = '<circle cx="58.5" cy="44.5" r="3.3" fill="#34d399"/><circle cx="8.5" cy="45" r="3.3" fill="#34d399"/>' +
          '<rect x="57.1" y="51.5" width="2.8" height="7" rx="1.4" fill="#fff" stroke="#0b7c4e" stroke-width="1.2"/>' +
          '<circle cx="58.5" cy="49" r="3.6" fill="#fff" stroke="#0b7c4e" stroke-width="1.4"/>' +
          '<circle cx="55.2" cy="47.6" r="1.6" fill="#fff" stroke="#0b7c4e" stroke-width="1.1"/>' +
          '<rect x="7.1" y="52" width="2.8" height="7" rx="1.4" fill="#fff" stroke="#0b7c4e" stroke-width="1.2"/>' +
          '<circle cx="8.5" cy="49.5" r="3.6" fill="#fff" stroke="#0b7c4e" stroke-width="1.4"/>' +
          '<circle cx="11.8" cy="48.1" r="1.6" fill="#fff" stroke="#0b7c4e" stroke-width="1.1"/>';
      } else {
        armen = '<path d="M50 33q6 -1 8 -8" stroke="#0f9d63" stroke-width="5.5" fill="none" stroke-linecap="round"/>' +
          '<path d="M14 35q-6 -1 -8 -8" stroke="#0f9d63" stroke-width="5.5" fill="none" stroke-linecap="round"/>';
        handen = '<circle cx="58" cy="25" r="3.3" fill="#34d399"/><circle cx="6" cy="27" r="3.3" fill="#34d399"/>' +
          '<circle cx="58.2" cy="20.6" r="4" fill="#fff" stroke="#0b7c4e" stroke-width="1.4"/>' +
          '<circle cx="54.6" cy="18.4" r="1.8" fill="#fff" stroke="#0b7c4e" stroke-width="1.2"/>' +
          '<circle cx="5.8" cy="22.6" r="4" fill="#fff" stroke="#0b7c4e" stroke-width="1.4"/>' +
          '<circle cx="9.4" cy="20.4" r="1.8" fill="#fff" stroke="#0b7c4e" stroke-width="1.2"/>';
      }
      return '<svg class="bv-mascotte knippert" viewBox="0 0 64 64" width="' + maat + '" height="' + maat + '" role="img" aria-label="De batterij-mascotte van Batterijenvoordeel">' +
        armen +
        '<rect x="25" y="3" width="14" height="7" rx="2.5" fill="#34d399"/>' +
        '<rect x="13" y="9" width="38" height="50" rx="11" fill="#0f9d63"/>' +
        '<rect x="18.5" y="14.5" width="27" height="39" rx="7.5" fill="#16211d"/>' +
        '<g class="ogen">' +
        '<circle cx="26.5" cy="28" r="3" fill="#eef2ef"/>' +
        '<circle cx="37.5" cy="28" r="3" fill="#eef2ef"/>' +
        '</g>' +
        '<path d="M26 35.5q6 5 12 0" stroke="#eef2ef" stroke-width="2.4" fill="none" stroke-linecap="round"/>' +
        '<path d="M34.5 41l-6.5 7.5h4.4l-2.4 6 7.8-8.8h-4.3l3-4.7z" fill="#34d399"/>' +
        handen +
        '</svg>';
    }
    /* De mascotte kruipt over de bovenrand van de donkere kaart en wijst met beide handjes de uitkomst aan */
    var GLUUR = '<span class="kaart-gluur" aria-hidden="true">' + mascotte(116, 'omlaag') + '</span>';

    /* v10: hoogstens twee voorkeuren; vanaf twee gaan de overige keuzes op slot */
    function voorkeuren() {
      var aan = [];
      for (var i = 0; i < voorkeurVelden.length; i++) if (voorkeurVelden[i].checked) aan.push(voorkeurVelden[i].value);
      return aan;
    }
    function voorkeurSlot() {
      var aantal = voorkeuren().length;
      for (var i = 0; i < voorkeurVelden.length; i++) {
        voorkeurVelden[i].disabled = aantal >= 2 && !voorkeurVelden[i].checked;
      }
    }

    function zvBalk(zv) {
      return '<span class="zv-balk" role="img" aria-label="Zelfvoorzienend: van ' + zv.zonder + ' naar ' + zv.met + ' procent">' +
        '<i style="width:' + zv.met + '%"></i><i class="zonder" style="width:' + zv.zonder + '%"></i></span>';
    }

    /* v6 (25 aug 2026, besluit Luc): alle vragen staan open; er wordt niets aangenomen voor vermogen
       en leeftijd. v10: wie 0 panelen invult hoeft vermogen en leeftijd niet meer in te vullen. */
    function verversen() {
      var panelen = Math.max(0, parseInt(velden.panelen.value, 10) || 0);
      var geenPanelen = ingevuld(velden.panelen) && panelen === 0;
      var wp = Math.max(0, parseInt(velden.wp.value, 10) || 0);
      var leeftijd = Math.min(40, Math.max(0, parseInt(velden.leeftijd.value, 10) || 0));
      /* Vuistregel NL: 1 Wp levert circa 0,9 kWh per jaar; panelen verouderen circa 0,5% per jaar */
      var degradatie = Math.pow(1 - 0.005, leeftijd);
      var invoer = {
        jaarverbruik: Math.max(0, parseInt(velden.verbruik.value, 10) || 0),
        panelen: panelen,
        jaaropwek: geenPanelen ? 0 : Math.round(panelen * wp * 0.9 * degradatie),
        dynamisch: velden.contract.value === 'dynamisch',
        kabelafstand: Math.max(0, parseInt(velden.kabel.value, 10) || 0)
      };
      var vk = voorkeuren();

      /* Aansluiting en zware verbruikers: geen prijseffect, wel eerlijke verwachtingen plus info voor de schouw */
      var aansluiting = velden.aansluiting ? velden.aansluiting.value : 'onbekend';
      var fase = aansluiting === '3' ? '3' : '1';
      var omvormer = velden.omvormer ? velden.omvormer.value : 'onbekend';
      var zwaar = [];
      for (var zi = 0; zi < zwaarVelden.length; zi++) if (zwaarVelden[zi].checked) zwaar.push(zwaarVelden[zi].value);

      /* Pas resultaten tonen als ALLE gegevens er staan, niet halverwege het typen.
         Zonder panelen zijn vermogen en leeftijd niet nodig. */
      var allesIngevuld = ingevuld(velden.verbruik) && ingevuld(velden.panelen) &&
        (geenPanelen || (ingevuld(velden.wp) && ingevuld(velden.leeftijd)));

      if (opwekRegel) {
        var degTekst = (leeftijd > 0) ? ', &minus;' + Math.round((1 - degradatie) * 100) + '% na ' + leeftijd + ' jaar' : '';
        opwekRegel.innerHTML = geenPanelen
          ? 'Geen zonnepanelen: de batterij kan dan alleen verdienen met slim laden op goedkope uren; vermogen en leeftijd hoef je niet in te vullen.'
          : ((panelen > 0 && wp > 0 && ingevuld(velden.leeftijd))
            ? 'Totale opwek: <strong>&plusmn;' + invoer.jaaropwek.toLocaleString('nl-NL') + ' kWh per jaar</strong> (' + panelen + ' &times; ' + wp + ' Wp &times; 0,9' + degTekst + ')'
            : 'Vul je panelen, het vermogen en de leeftijd in; hier verschijnt je totale opwek.');
      }

      var leeg = (!berekend || !allesIngevuld || invoer.jaarverbruik === 0);
      var status = wortel.querySelector('[data-bv-status]');
      if (status) {
        status.textContent = leeg
          ? 'Vul hierboven al je gegevens in en klik op Bereken mijn batterij.'
          : 'Live berekend met jouw gegevens: ' + invoer.jaarverbruik.toLocaleString('nl-NL') + ' kWh, ' +
            (geenPanelen ? 'geen panelen' : invoer.panelen + ' panelen van ' + wp + ' Wp (' + leeftijd + ' jaar oud)') + ', ' +
            (invoer.dynamisch ? 'dynamisch' : 'vast') + ' contract. Pas een veld aan en alles rekent direct mee.';
      }

      /* Open box: geen vooringevulde cijfers; de mascotte nodigt uit tot invullen.
         Moet VOOR de berekeningen staan: met lege invoer is er niets te sorteren. */
      if (leeg) {
        samenvatting.innerHTML =
          '<div class="bv-beste bv-open">' + GLUUR +
            '<div class="bv-beste-kop"><div>' +
            '<span class="bv-beste-label">Jouw beste keuze verschijnt hier</span>' +
            '<h3>Reken het uit</h3></div></div>' +
            '<p class="bv-open-tekst">Vul links je gegevens in en klik op Bereken mijn batterij. Ik reken dan uit welke batterij bij j&oacute;uw huis past, wat hij oplevert en hoe zelfvoorzienend je wordt. Eerlijk gerekend, geen account, geen verkoper aan de lijn.</p>' +
            '<ul class="bv-open-lijst">' +
              '<li>Beide merken naast elkaar</li>' +
              '<li>Eerlijke terugverdientijd, geen reclamecijfers</li>' +
              '<li>Vink aan wat jij belangrijk vindt; het advies kiest mee</li>' +
            '</ul>' +
          '</div>';
        uitvoer.innerHTML = '';
        var mailLeeg = document.querySelector('[data-bv-mail-veld]');
        if (mailLeeg) mailLeeg.value = '';
        laatsteBerekening = null;
        return;
      }

      /* v10: de drie lagen. Band bepalen, per merk een maat kiezen, uitsluiten en punten geven. */
      var band = adviesBand(invoer, vk);
      var rijen = adviseer(invoer, fase, vk, band);
      var beste = rijen[0];
      var mee = rijen.filter(function (r) { return !r.uitgesloten; });
      var geldTop = mee.slice().sort(function (a, b) { return b.res.netto15 - a.res.netto15; })[0];
      var zvTop = mee.slice().sort(function (a, b) { return (b.zv ? b.zv.ruw : 0) - (a.zv ? a.zv.ruw : 0); })[0];
      var voordeligste = mee.slice().sort(function (a, b) { return a.res.investering - b.res.investering; })[0];
      var alleUitgesloten = mee.length === 0;

      /* De eerlijke uitkomst: levert niets op, of verdient zich niet binnen vijftien jaar terug. */
      var nietNu = !alleUitgesloten && (beste.res.jaar1Verwacht <= 0 || beste.res.tvAdvies === null || beste.res.tvAdvies > 15);

      if (alleUitgesloten) {
        samenvatting.innerHTML = '<p class="bv-melding">Met deze wensen samen hebben we geen passend systeem: ' +
          rijen.map(function (r) { return r.bat.naam + ': ' + (r.uitgesloten || '').toLowerCase(); }).join('; ') +
          '. Haal &eacute;&eacute;n wens weg en het advies rekent direct opnieuw.</p>';
      } else if (nietNu) {
        var beter = [];
        if (!invoer.dynamisch) beter.push('met een dynamisch contract gaat de batterij ook handelen op de uurprijzen; dat maakt het verschil het snelst goed');
        if (invoer.jaaropwek === 0) beter.push('met zonnepanelen erbij slaat de batterij je eigen stroom op in plaats van alleen te handelen');
        else if (invoer.jaaropwek < invoer.jaarverbruik * 0.7) beter.push('met meer panelen is er meer eigen stroom om op te slaan');
        samenvatting.innerHTML =
          '<div class="bv-beste bv-open">' + GLUUR +
            '<div class="bv-beste-kop"><div>' +
            '<span class="bv-beste-label">Ons eerlijke advies</span>' +
            '<h3>Nu nog even wachten</h3></div></div>' +
            /* 15 okt 2026, tekst Luc via Gemini: de vaste zin over warmtepomp en dynamisch contract is vervangen door de
               lijst "beter", die per huishouden alleen noemt wat bij die invoer echt het verschil maakt. */
            '<p class="bv-open-tekst">Op basis van jouw gegevens duurt het op dit moment te lang om de batterij terug te verdienen.' +
            (beter.length ? ' Wat het w&eacute;l goed zou maken: ' + beter.join(', en ') + '.' : '') +
            ' Wij adviseren je daarom om de investering nog even uit te stellen. We verkopen je liever niets dan een systeem dat niet optimaal voor je werkt.' +
            ' De cijfers staan hieronder, zodat je het zelf kunt zien.</p>' +
          '</div>';
      } else {
        var eerlijk = '';
        /* 8 okt 2026 (taak 149): de bandbreedte staat alleen in de reden als de maat er echt binnen valt;
           anders noemt deze eerlijke zin wat het huis nodig heeft, zodat de kaart zichzelf niet tegenspreekt. */
        var nodigTekst = band ? (band.vanTekst === band.totTekst ? 'ongeveer ' + band.vanTekst : band.vanTekst + ' tot ' + band.totTekst) + ' kWh netto' : '';
        if (beste.oordeel === 'ruim' || beste.oordeel === 'te-groot') {
          /* 9 okt 2026 (taak 171): "kleiner leveren we niet" klopt alleen bij de kleinste maat. Bij een
             grotere maat noemen we wat de maat eronder bij deze klant doet. */
          var kleiner = '';
          if (beste.bat.modules > 0) {
            var onder = berekenAdvies(invoer, maat(beste.bat, beste.bat.fase, beste.bat.modules - 1));
            if (onder.tvAdvies === null || onder.jaar1Verwacht <= 0 || onder.tvAdvies > 15) kleiner = 'Bij de maat eronder duurt het bij jou te lang om hem terug te verdienen';
            else if (beste.res.tvAdvies !== null && onder.tvAdvies > beste.res.tvAdvies) kleiner = 'De maat eronder verdient zich bij jou pas in ' + onder.tvAdvies + ' jaar terug';
            else kleiner = 'Wil je toch kleiner, kies dan in de configurator de maat eronder';
          } else kleiner = 'Kleiner leveren we dit systeem niet';
          eerlijk += 'Eerlijk gezegd: jouw huis heeft genoeg aan ' + nodigTekst + '; deze maat is ' + (beste.oordeel === 'te-groot' ? 'flink groter' : 'wat ruimer') + '. ' + kleiner +
            (invoer.dynamisch ? ', en deze maat verdient de extra capaciteit terug met slim handelen op je dynamische contract. ' : '. ');
        } else if (beste.oordeel === 'krap') {
          eerlijk += 'Eerlijk gezegd: jouw huis kan ' + nodigTekst + ' gebruiken; deze maat zit daar iets onder, omdat de volgende maat van dit systeem flink groter is. Wil je meer opslag, kies dan in de configurator een grotere maat. ';
        }
        if (beste.res.plafondActief) {
          eerlijk += 'Goed om te weten: bij jouw verbruik zit de winst niet in n&oacute;g meer capaciteit; je huis krijgt de opgeslagen stroom &rsquo;s nachts niet op. ';
        } else if (beste.res.overschotGroterDanBatterij) {
          eerlijk += 'Je panelen leveren meer overschot dan deze batterij kan opslaan; de rest gaat tegen de terugleververgoeding het net op. ';
        }
        /* Aansluitroute: hoe de batterij naast of in plaats van de huidige omvormer komt. Geen prijseffect. */
        if (omvormer === 'micro') {
          eerlijk += 'Je hebt micro-omvormers of optimizers: wij plaatsen de batterij als los systeem naast je installatie; je panelen en Enphase/SolarEdge-spullen blijven volledig ongemoeid. ';
        } else if (omvormer === 'gewoon') {
          if (beste.bat.routes === 'beide') {
            eerlijk += 'Met je huidige omvormer kun je bij deze batterij kiezen: als los systeem ernaast (je omvormer blijft hangen) of je oude omvormer laten vervangen zodat alles &eacute;&eacute;n systeem wordt. Zelfde prijs; je kiest definitief bij de schouw. ';
          } else if (beste.bat.routes === 'beide-meerprijs') {
            eerlijk += 'Standaard plaatsen we deze batterij als los systeem naast je huidige installatie; je omvormer blijft dan gewoon hangen. Wil je juist dat je zonnepanelen op de nieuwe omvormer komen, dan kan dat met de hybride uitvoering voor &euro; ' + beste.bat.hybride + ' extra. Je kiest bij de schouw. ';
          } else {
            eerlijk += 'Deze batterij plaatsen we als los systeem naast je huidige installatie; je omvormer blijft gewoon hangen. ';
          }
          eerlijk += '<a href="/pages/thuisbatterij-omvormer">Zo zit dat</a>. ';
        } else if (omvormer === 'onbekend' && !geenPanelen) {
          eerlijk += 'Hoe we de batterij op je huidige zonnepanelen aansluiten? De installateur kijkt bij de schouw mee en adviseert wat het slimst is; er is altijd een passende route. ';
        }
        if (aansluiting === '3') {
          eerlijk += 'Je hebt 3-fase: alle prijzen hieronder zijn voor de 3-fase uitvoering, met een omvormer die bij je aansluiting en je batterij past. ';
          if (zwaar.length === 0) {
            var eenFase = kiesMaat(BATTERIJEN.filter(function (b) { return b.id === beste.bat.id; })[0], '1', band, invoer, vk);
            if (eenFase && eenFase.prijs < beste.bat.prijs) {
              eerlijk += 'Zonder warmtepomp, laadpaal of elektrisch koken kan de 1-fase uitvoering (' + euro(eenFase.prijs) + ') op jouw aansluiting ook prima; de installateur adviseert bij de schouw. ';
            }
          }
        } else if (aansluiting !== '1') {
          eerlijk += 'Weet je niet of je 1 of 3 fasen hebt? We rekenen met de 1-fase uitvoering; heb je 3 fasen, dan heeft elke set een eigen 3-fase prijs. De installateur controleert je aansluiting bij de schouw. ';
        }
        if (aansluiting === '1' && zwaar.length > 0) {
          eerlijk += 'Let op: met een ' + (zwaar.indexOf('warmtepomp') > -1 ? 'warmtepomp' : (zwaar.indexOf('laadpaal') > -1 ? 'laadpaal' : 'elektrische kookplaat')) + ' op een 1-fase aansluiting raakt je hoofdzekering sneller vol. De batterij kan pieken juist opvangen; of verzwaren naar 3-fase zinvol is, bekijkt de installateur gratis bij de schouw. ';
        }
        if (vk.indexOf('noodstroom') > -1) {
          var ns = (beste.eigen.noodstroom || {})[fase] || 'geen';
          eerlijk += 'Noodstroom: bij dit systeem ' + NOODSTROOM_TEKST[ns] + '. ';
        }
        var financiering = beste.res.bovenMax
          ? euro(C.warmtefondsMax) + ' via Warmtefonds, ' + euro(beste.res.investering - C.warmtefondsMax) + ' zelf'
          : 'vanaf &euro; ' + beste.res.perMaand.toFixed(2).replace('.', ',') + ' p/m';
        var reden = beste.redenen.length
          ? beste.redenen.slice(0, 2).join(', en ')
          : 'het meeste geld over na vijftien jaar';
        var bandTekst = band ? band.vanTekst + ' tot ' + band.totTekst + ' kWh netto' : '';
        /* v11: ook verbruik, opwek en contract mee, zodat de configurator de terugverdientijd voor
           dit huis kan tonen; alleen getallen, geen persoonsgegevens */
        var configuratorUrl = '/pages/samenstellen?merk=' + (beste.eigen.key || '') + '&fase=' + fase + '&kwh=' + String(beste.bat.capaciteit).replace('.', ',') +
          '&v=' + invoer.jaarverbruik + '&o=' + invoer.jaaropwek + '&c=' + (invoer.dynamisch ? 'dyn' : 'vast');
        samenvatting.innerHTML =
          '<div class="bv-beste">' + GLUUR +
            '<div class="bv-beste-kop"><div>' +
            '<span class="bv-beste-label">Ons advies voor jouw situatie</span>' +
            '<h3>' + beste.bat.naam + ' &middot; ' + brutoTekst(beste.bat) + ' kWh</h3></div></div>' +
            '<p class="bv-reden">Waarom deze: ' + reden + (bandTekst && beste.oordeel === 'past' ? ', en de maat valt binnen jouw bandbreedte van ' + bandTekst : '') + '.</p>' +
            /* 6 okt 2026, besluit Luc (richting B): prijs inclusief btw en na btw-teruggave naast elkaar */
            '<div class="bv-tweeprijs donker">' +
              '<div><span class="lab">Voor btw-teruggave</span><span class="bedrag">' + euro(beste.res.investering) + '</span><span class="onder">inclusief btw</span></div>' +
              naBtwVak(beste.res.investering, beste.bat.id + '|' + beste.bat.fase + '|' + beste.bat.capaciteit) + '</div>' +
            '<div class="bv-beste-cijfers">' +
              '<div><span class="lab">Levert per jaar op</span><span class="val groen">' + bereik(beste.res.jaar1, beste.res.jaar1Verwacht) + '</span></div>' +
              '<div><span class="lab">Terugverdiend in</span><span class="val">' + tvTekst(beste.res) + '</span></div>' +
              '<div><span class="lab">Zelfvoorzienend, van eigen dak</span><span class="val groen">' + beste.zv.zonder + '% &rarr; ' + beste.zv.met + '%</span></div>' +
              '<div><span class="lab">Capaciteit' + (bandTekst ? ' (jouw bandbreedte: ' + bandTekst + ')' : '') + '</span><span class="val">' + brutoTekst(beste.bat) + ' kWh' + (beste.bat.maatTekst ? ' <small>(' + beste.bat.maatTekst + ')</small>' : '') + '</span></div>' +
              '<div><span class="lab">Financiering met 0% rente</span><span class="val">' + financiering + '</span></div>' +
            '</div>' +
            '<div class="bv-beste-acties"><a class="btn btn-primair" href="' + configuratorUrl + '">Stel deze samen, vraag een offerte aan <span class="pijl">&rarr;</span></a>' +
            '<a class="bv-link" href="' + beste.bat.url + '">Of bekijk het product</a></div>' +
            '<p class="bv-voetnoot">' + eerlijk +
            'De opbrengst is een bandbreedte, omdat hij afhangt van hoe sterk de stroomprijzen schommelen. ' +
            'Gerekend zonder salderen, met laadverlies, veroudering en de terugleverkosten die je vermijdt. ' +
            (beste.res.bovenMax ? 'Het Warmtefonds leent maximaal ' + euro(C.warmtefondsMax) + '; het restant betaal je zelf of financier je elders. ' : '') +
            'Of jij het Warmtefonds kunt gebruiken, zie je in twee minuten met de <a href="/pages/warmtefonds">Warmtefonds-check</a>.</p>' +
          '</div>';
      }

      var persoonlijk = '';
      if (band && invoer.jaarverbruik > 0) {
        persoonlijk = '<p class="calc-persoonlijk">Jouw situatie: <strong>' + invoer.jaarverbruik.toLocaleString('nl-NL') + ' kWh</strong> verbruik en <strong>' +
          (geenPanelen ? 'geen panelen' : invoer.panelen + ' panelen</strong> (±' + invoer.jaaropwek.toLocaleString('nl-NL') + ' kWh opwek') + (geenPanelen ? '</strong>' : ')') + '. ' +
          'Passende opslag voor jouw huis: <strong>' + band.vanTekst + ' tot ' + band.totTekst + ' kWh</strong>' +
          (invoer.dynamisch ? ' (met jouw dynamische contract laadt de batterij ook &rsquo;s nachts goedkoop bij, dus wat extra capaciteit loont)' : ' (meer heeft geen zin: je dak vult het niet en je huis krijgt het &rsquo;s nachts niet op)') +
          (vk.length ? '. Jouw voorkeuren: <strong>' + vk.map(function (v) { return VOORKEUR_TEKST[v]; }).join(', ') + '</strong>' : '') +
          '. Elk merk staat hieronder in de maat die daarbij past; vink voorkeuren aan en het advies kiest mee.</p>';
      }

      var html = persoonlijk + '<table class="bv-tabel modus-advies"><thead>' +
        '<tr>' +
        '<th>Batterij</th>' +
        '<th>Capaciteit</th>' +
        '<th class="zv-kop">Zelfvoorzienend</th>' +
        '<th class="scen">Totaalprijs</th>' +
        '<th class="scen">Na btw-teruggave</th>' +
        '<th class="scen">Opbrengst per jaar</th>' +
        '<th></th>' +
        '</tr></thead><tbody>';
      rijen.forEach(function (r, i) {
        var labels = '';
        if (!r.uitgesloten) {
          if (i === 0 && !nietNu) labels += '<em class="match-label groenlicht">Ons advies</em>';
          if (geldTop && r.bat.id === geldTop.bat.id) labels += '<em class="match-label">Beste rendement</em>';
          if (zvTop && r.bat.id === zvTop.bat.id && r.zv && zvTop.zv && mee.length > 1 && zvTop.zv.ruw > Math.min.apply(null, mee.map(function (m) { return m.zv ? m.zv.ruw : 0; }))) labels += '<em class="match-label">Meest zelfvoorzienend</em>';
          if (voordeligste && r.bat.id === voordeligste.bat.id) labels += '<em class="match-label">Laagste prijs</em>';
          if (vk.indexOf('noodstroom') > -1 && (r.eigen.noodstroom || {})[fase] === 'ingebouwd') labels += '<em class="match-label">Noodstroom in de omvormer</em>';
          if (vk.indexOf('noodstroom') > -1 && (r.eigen.noodstroom || {})[fase] === 'los') labels += '<em class="match-label">Noodstroom met los kastje</em>';
          if (vk.indexOf('eenmerk') > -1 && r.eigen.eenMerk) labels += '<em class="match-label">Alles van &eacute;&eacute;n merk</em>';
          labels += '<em class="match-label' + (r.oordeel === 'past' ? ' groenlicht' : '') + '">' + OORDEEL_TEKST[r.oordeel] + '</em>';
        }
        var configTekst = r.bat.maatTekst || r.bat.klasse;
        html += '<tr' + (i === 0 && !r.uitgesloten && !nietNu ? ' class="uitgelicht"' : (r.uitgesloten ? ' class="bv-uitgesloten"' : '')) + '>' +
          '<td data-lab="Batterij"><strong>' + r.bat.naam + '</strong><span class="bv-klein">' + r.bat.positionering + '</span>' +
            (labels ? '<span class="match-rij">' + labels + '</span>' : '') +
            (r.uitgesloten ? '<em class="bv-let">Valt af bij jouw wensen: ' + r.uitgesloten.toLowerCase() + '</em>' : '') + '</td>' +
          '<td data-lab="Capaciteit" class="cijfer">' + brutoTekst(r.bat) + ' kWh<span class="jr">' + configTekst + '</span></td>' +
          '<td data-lab="Zelfvoorzienend" class="zv"><span class="cijfer">' + r.zv.met + '%</span>' + zvBalk(r.zv) + '<span class="bv-klein">zonder batterij ' + r.zv.zonder + '%</span></td>' +
          '<td data-lab="Totaalprijs" class="cijfer scen">' + euro(r.res.investering) + '<span class="jr">' + euro(r.res.perKwh) + ' per kWh</span></td>' +
          '<td data-lab="Na btw-teruggave" class="cijfer scen groen">' + (function (n) {
            return !n ? '' : (n.opMaat ? 'op maat' : euro(n.bedrag) + '<span class="jr">inclusief installatie</span>');
          })(naBtw(r.res.investering, r.bat.id + '|' + r.bat.fase + '|' + r.bat.capaciteit)) + '</td>' +
          '<td data-lab="Opbrengst per jaar" class="cijfer scen">' + bereik(r.res.jaar1, r.res.jaar1Verwacht, ' &ndash; ') +
            '<span class="jr">terugverdiend in ' + tvTekst(r.res, true) + '</span></td>' +
          '<td data-lab=""><a class="bv-link" href="' + r.bat.url + '">Bekijken</a></td>' +
          '</tr>';
      });
      html += '</tbody></table>';
      html += '<p class="tabel-noot">De opbrengst is een bandbreedte, omdat hij afhangt van hoe sterk de stroomprijzen schommelen. Hoe we rekenen lees je op <a href="/pages/hoe-wij-rekenen">hoe wij rekenen</a>.</p>';
      uitvoer.innerHTML = html;

      /* Samenvatting meesturen als iemand de berekening per mail wil */
      var mailVeld = document.querySelector('[data-bv-mail-veld]');
      if (mailVeld) {
        var regels = rijen.map(function (r) {
          return r.bat.naam + ' ' + brutoTekst(r.bat) + ' kWh op ' + (r.bat.fase === '3' ? '3 fasen' : '1 fase') + ': ' + euro(r.res.investering) + ' | ' + euro(r.res.jaar1) + '-' + euro(r.res.jaar1Verwacht) +
            ' per jaar | terugverdiend in ' + tvTekst(r.res, true) + ' | zelfvoorzienend ' + r.zv.zonder + '->' + r.zv.met +
            '% | Warmtefonds ' + r.res.perMaand.toFixed(2).replace('.', ',') + ' p/m' +
            (r.uitgesloten ? ' | valt af: ' + r.uitgesloten : '');
        });
        mailVeld.value =
          'Verbruik: ' + invoer.jaarverbruik + ' kWh | Panelen: ' + (geenPanelen ? 'geen' : invoer.panelen + ' x ' + wp + ' Wp (±' + invoer.jaaropwek + ' kWh)') +
          ' | Contract: ' + (invoer.dynamisch ? 'dynamisch' : 'vast') + ' | Kabel: ' + invoer.kabelafstand + ' m' +
          ' | Aansluiting: ' + (aansluiting === '1' ? '1-fase' : (aansluiting === '3' ? '3-fase' : 'onbekend')) +
          ' | Huidige omvormer: ' + (omvormer === 'gewoon' ? 'gewone omvormer' : (omvormer === 'micro' ? 'micro-omvormers/optimizers (Enphase/SolarEdge)' : 'onbekend')) +
          (zwaar.length ? ' | Zware verbruikers: ' + zwaar.join(', ') : '') +
          ' | Voorkeuren: ' + (vk.length ? vk.map(function (v) { return VOORKEUR_TEKST[v]; }).join(', ') : 'geen gekozen, gerekend op rendement') +
          (band ? ' | Bandbreedte: ' + band.vanTekst + '-' + band.totTekst + ' kWh' : '') +
          ' | Advies: ' + (alleUitgesloten ? 'geen passend systeem bij deze wensen' : (nietNu ? 'nu nog niet kopen' : beste.bat.naam + ' ' + brutoTekst(beste.bat) + ' kWh')) + '\n\n' +
          regels.join('\n');
      }

      /* v12 (5 okt 2026): de berekening als losse getallen en vaste keuzes, voor de mail via Make.
         Bewust geen vrije tekst en geen link: Make bouwt de mail en de link zelf uit deze waarden,
         zodat niemand via dit formulier een eigen tekst vanaf info@ kan laten versturen. */
      laatsteBerekening = {
        invoer: {
          v: invoer.jaarverbruik, p: invoer.panelen, wp: geenPanelen ? 0 : wp, l: geenPanelen ? 0 : leeftijd, jo: invoer.jaaropwek,
          c: invoer.dynamisch ? 'dyn' : 'vast', f: aansluiting === '3' ? '3' : (aansluiting === '1' ? '1' : '0'),
          k: invoer.kabelafstand, o: omvormer, z: zwaar.slice(), vk: vk.slice()
        },
        status: alleUitgesloten ? 'geen' : (nietNu ? 'nietnu' : 'advies'),
        set: alleUitgesloten ? null : (beste.bat.id + '|' + beste.bat.fase + '|' + beste.bat.capaciteit),
        uitkomst: alleUitgesloten ? null : {
          jaar1: beste.res.jaar1, jaar1Verwacht: beste.res.jaar1Verwacht, tv: beste.res.tv, tvVerwacht: beste.res.tvVerwacht,
          zvZonder: beste.zv ? beste.zv.zonder : 0, zvMet: beste.zv ? beste.zv.met : 0, investering: beste.res.investering
        },
        band: band ? { van: band.vanTekst, tot: band.totTekst } : null
      };
    }

    function flits() {
      var doelen = [samenvatting, uitvoer, wortel.querySelector('[data-bv-status]')].filter(Boolean);
      doelen.forEach(function (el) { el.classList.remove('bv-flits'); });
      /* herstart de animatie ook bij snel opnieuw klikken */
      void samenvatting.offsetWidth;
      doelen.forEach(function (el) { el.classList.add('bv-flits'); });
      if (flitsTimer) clearTimeout(flitsTimer);
      flitsTimer = setTimeout(function () {
        doelen.forEach(function (el) { el.classList.remove('bv-flits'); });
      }, 1300);
    }

    Object.keys(velden).forEach(function (k) {
      if (!velden[k]) return;
      velden[k].addEventListener('input', verversen);
      velden[k].addEventListener('change', verversen);
    });
    for (var zj = 0; zj < zwaarVelden.length; zj++) zwaarVelden[zj].addEventListener('change', verversen);
    for (var i = 0; i < voorkeurVelden.length; i++) {
      voorkeurVelden[i].addEventListener('change', function () { voorkeurSlot(); verversen(); flits(); });
    }
    if (berekenKnop) {
      berekenKnop.addEventListener('click', function () {
        var panelenNul = ingevuld(velden.panelen) && (parseInt(velden.panelen.value, 10) || 0) === 0;
        var verplicht = panelenNul ? [velden.verbruik, velden.panelen] : [velden.verbruik, velden.panelen, velden.wp, velden.leeftijd];
        var eersteLeeg = verplicht.filter(function (el) { return !ingevuld(el); })[0];
        if (eersteLeeg) {
          /* nog niet compleet: naar het eerstvolgende lege veld sturen */
          eersteLeeg.focus();
        } else {
          berekend = true;
          verversen();
          flits();
          samenvatting.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      });
    }
    /* v12 (5 okt 2026): een berekening terugzetten uit de link, bijvoorbeeld de knop in de mail.
       Alleen getallen binnen vaste grenzen en waarden uit vaste lijsten; de rest wordt genegeerd. */
    (function vulUitLink() {
      var p;
      try { p = new URLSearchParams(location.search); } catch (e) { return; }
      if (!p.get('v')) return;
      berekend = true; /* een link met een berekening toont de uitkomst meteen */
      var getal = function (k, max) { var n = parseInt(p.get(k), 10); return (n >= 0 && n <= max) ? String(n) : null; };
      var zet = function (el, w) { if (el && w !== null) el.value = w; };
      zet(velden.verbruik, getal('v', 100000));
      zet(velden.panelen, getal('p', 500));
      if (getal('p', 500) !== '0') { zet(velden.wp, getal('wp', 800)); zet(velden.leeftijd, getal('l', 40)); }
      zet(velden.kabel, getal('k', 100));
      if (p.get('c') === 'vast' || p.get('c') === 'dyn') velden.contract.value = p.get('c') === 'vast' ? 'vast' : 'dynamisch';
      if (/^[13]$/.test(p.get('f') || '')) velden.aansluiting.value = p.get('f');
      if (['gewoon', 'micro', 'onbekend'].indexOf(p.get('o')) > -1 && velden.omvormer) velden.omvormer.value = p.get('o');
      var lijst = function (k) { return String(p.get(k) || '').split(',').filter(Boolean); };
      var z = lijst('z');
      for (var a = 0; a < zwaarVelden.length; a++) zwaarVelden[a].checked = z.indexOf(zwaarVelden[a].value) > -1;
      var vkl = lijst('vk').slice(0, 2);
      for (var b = 0; b < voorkeurVelden.length; b++) voorkeurVelden[b].checked = vkl.indexOf(voorkeurVelden[b].value) > -1;
    })();

    /* v12: "Deze berekening in je mailbox". Staat er een Make-adres in de sectie-instellingen, dan gaat
       de berekening daarheen en stuurt Make hem via Zoho naar de klant, ook als niemand achter een
       laptop zit. Zonder dat adres valt het formulier terug op het gewone contactformulier van Shopify. */

    /* 12 okt 2026 (snelheid, opdracht Luc): het script van Cloudflare (ongeveer 785 kB met zijn controle) laadt pas
       als de bezoeker in de buurt van het formulier komt of erin klikt, niet meer bij het openen van elke pagina.
       De controle zelf is ongewijzigd: zonder geldig vinkje gaat er niets naar Make. */
    function bvLaadTurnstile(klaar) {
      if (window.turnstile && window.turnstile.render) { klaar(); return; }
      (window.__bvTsWacht = window.__bvTsWacht || []).push(klaar);
      if (window.__bvTsLaadt) return;
      window.__bvTsLaadt = true;
      var s = document.createElement('script');
      s.src = 'https://challenges.cloudflare.com/turnstile/v0/api.js?render=explicit';
      s.async = true;
      s.onload = function () { var w = window.__bvTsWacht || []; window.__bvTsWacht = []; w.forEach(function (f) { try { f(); } catch (x) { /* niets */ } }); };
      document.head.appendChild(s);
    }
    function bvWanneerInBeeld(el, doe) {
      var gedaan = false;
      function start() { if (gedaan) return; gedaan = true; doe(); }
      var vorm = el.closest('form') || el;
      ['pointerdown', 'focusin', 'keydown'].forEach(function (t) { vorm.addEventListener(t, start, { once: true }); });
      if (!('IntersectionObserver' in window)) { start(); return; }
      var io = new IntersectionObserver(function (items) {
        if (items.some(function (i) { return i.isIntersecting; })) { io.disconnect(); start(); }
      }, { rootMargin: '600px 0px' });
      io.observe(el);
    }
    var mailForm = wortel.querySelector('.calc-mail form');
    var webhook = wortel.getAttribute('data-bv-mail-webhook') || '';
    var tsSleutel = wortel.getAttribute('data-bv-turnstile') || '';
    if (mailForm && /^https:\/\/hook\.eu\d*\.make\.com\//.test(webhook)) {
      /* Los van het contactformulier van Shopify: anders start Shopify bij versturen ook zijn eigen
         plaatjescontrole en post het daarna alsnog naar info@. Een kopie zonder de koppelingen van
         Shopify, zonder doeladres en zonder formuliersoort; de botcontrole doet Cloudflare. */
      var kaal = mailForm.cloneNode(true);
      kaal.removeAttribute('action');
      kaal.removeAttribute('method');
      Array.prototype.forEach.call(kaal.querySelectorAll('input[type="hidden"]'), function (el) { el.parentNode.removeChild(el); });
      mailForm.parentNode.replaceChild(kaal, mailForm);
      mailForm = kaal;
      /* Cloudflare tekent zijn controle pas hier, in de kopie (het script laadt met render=explicit) */
      var tsVak = mailForm.querySelector('.cf-turnstile');
      var tsId = null;
      if (tsSleutel && tsVak) {
        tsVak.innerHTML = '';
        var pogingen = 0;
        var teken = function () {
          if (window.turnstile && window.turnstile.render) {
            try { tsId = window.turnstile.render(tsVak, { sitekey: tsSleutel, language: 'nl' }); } catch (x) { tsId = null; }
          } else if (pogingen++ < 60) setTimeout(teken, 250);
        };
        bvWanneerInBeeld(tsVak, function () { bvLaadTurnstile(teken); });
      }
      var mailStatus = wortel.querySelector('[data-bv-mail-status]');
      var toon = function (tekst, goed) {
        if (!mailStatus) return;
        mailStatus.hidden = false;
        mailStatus.className = 'mail-gelukt' + (goed ? '' : ' mail-fout');
        mailStatus.textContent = tekst;
      };
      mailForm.addEventListener('submit', function (e) {
        e.preventDefault();
        e.stopImmediatePropagation();
        var veldMail = mailForm.querySelector('input[type="email"]');
        var adres = veldMail ? veldMail.value.trim() : '';
        if (!/^[^\s@]{1,64}@[^\s@]{1,190}\.[a-z]{2,}$/i.test(adres) || adres.length > 50) { toon('Vul een geldig e-mailadres in.', false); return; }
        if (!laatsteBerekening) { toon('Vul eerst je gegevens hierboven in; dan sturen we je de uitkomst.', false); return; }
        var token = '';
        if (tsSleutel) {
          try { token = (window.turnstile && tsId !== null) ? window.turnstile.getResponse(tsId) : ''; } catch (x) { token = ''; }
          if (!token) { toon('Vink eerst het vakje "Ik ben geen robot" aan. Staat er al een groen vinkje, probeer het dan zo nog eens.', false); return; }
        }
        var knop = mailForm.querySelector('button[type="submit"]');
        if (knop) knop.disabled = true;
        /* 8 okt 2026, taak 159: het antwoord op "Hoe heb je ons gevonden?" en, alleen met toestemming in
           de cookiemelding, waar het bezoek vandaan kwam (snippets/bv-herkomst.liquid). Make zet dit
           alleen in een aparte interne mail aan info@. */
        var gevVeld = mailForm.querySelector('[data-bv-gevonden]');
        var verzoek = { soort: 'berekening', email: adres, berekening: laatsteBerekening, turnstile: token,
          gevonden: gevVeld && /^(google|social|kennis|anders)$/.test(gevVeld.value) ? gevVeld.value : '' };
        try { var herkomst = window.BV_HERKOMST ? window.BV_HERKOMST.lees() : null; if (herkomst) verzoek.herkomst = herkomst; } catch (x) { /* niets */ }
        fetch(webhook, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(verzoek)
        }).then(function (r) {
          if (!r.ok) throw new Error('status ' + r.status);
          toon('Gelukt, je berekening is onderweg naar ' + adres + '. Kijk ook even in je spam-map.', true);
          mailForm.reset();
        }).catch(function () {
          toon('Het versturen lukte niet. Probeer het over een minuut nog eens, of mail ons op info@batterijenvoordeel.nl.', false);
        }).then(function () {
          if (knop) knop.disabled = false;
          try { if (tsId !== null && window.turnstile) window.turnstile.reset(tsId); } catch (x) { /* niets */ }
        });
      });
    }

    voorkeurSlot();
    verversen();
  }

  /* v11: de configurator en andere pagina's rekenen met precies dezelfde prijzen en formules */
  if (typeof window !== 'undefined') {
    window.BV_REKEN = { BATTERIJEN: BATTERIJEN, EIGEN: EIGEN, OFFERTES: OFFERTES, naBtw: naBtw, naBtwVak: naBtwVak, maat: maat, configureer: configureer,
      bereken: bereken, referentie: referentie, tvTekst: tvTekst, euro: euro, C: C, M: M, metNaBtw: metNaBtw,
      /* 12 okt 2026 (taak 200): de rekenhulp is nu de configurator in de stand "rekenhulp" en kiest merk en maat hiermee */
      adviesBand: adviesBand, adviseer: adviseer, maatOordeel: maatOordeel, kiesMaat: kiesMaat,
      /* 12 okt 2026 (taak 156): grote verbruikers, voor rekenhulp en configurator */
      extraVerbruik: extraVerbruik, VERBRUIKERS: VERBRUIKERS,
      /* 13 okt 2026 (besluit Luc): zelfvoorzienend weer zichtbaar in de configurator, met de regel van v16 */
      zelfvoorziening: zelfvoorziening,
      /* 21 okt 2026 (taak 272): het directe deel van de opwek per huis */
      directVanDak: directVanDak };
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
